import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import { Subscription} from 'rxjs';
import {ContainerView} from '../../Interfaces/ContainerView';
import {ListData} from '../../Interfaces/ListData';
import {SelectionModel} from '@angular/cdk/collections';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Charge} from '../../Interfaces/Charge';
import {CreditCard} from '../../Interfaces/CreditCard';
import {GuaranteesView} from '../../Interfaces/GuaranteesView';
import {ContainerGuarantee} from '../../Interfaces/ContainerGuarantee';
import {ContainerGuaranteeDisplay} from '../../Interfaces/ContainerGuaranteeDisplay';
import {GlobalEventsManager} from '../../GlobalEventManager';
import * as XLSX from 'xlsx';
import {ContainerViewChargesExcel} from '../../Interfaces/ContainerViewChargesExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatCalendarCellCssClasses, MatDatepicker} from '@angular/material/datepicker';
import {MatStepper} from '@angular/material/stepper';

import moment from "moment";


@Component({
  selector: 'app-import-export-charges',
  templateUrl: './import-export-charges.component.html',
  styleUrls: ['./import-export-charges.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ImportExportChargesComponent implements OnInit, OnDestroy {
  search1: UntypedFormControl;

  myUser: User;
  txtFromArea: string = " ";
  submitted = false;
  oneIsInAlready = false;
  badDate = false;
  noCC = false;
  nothingSelected = false;
  missingDate: boolean = false;
  missingRef: boolean = false;
  redeliverRecord: boolean = false;
  missingBoth: boolean = false;
  containerOut: string;
  typeOut: string;
  holdDate: string;
  screenMode: string = "I";
  theError: string;
  badContainer: boolean = false; totalAmountMaherDisp: string; totalAmountLineDisp : string; foundStorageSSL: boolean = false; showMaherStatement: boolean=false; needToCheckOffStorageSSL: boolean =false; needToCheckOffStorageMaher: boolean = false;
  public didntEnterShit: boolean = false;
  public noPayType: boolean = false;
  public badChars: boolean = false;
  public badRemarks: boolean = false;
  public showQuickView: boolean = false;
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  public showQuickView2: boolean = false;
  public showDetailScreen: boolean = false;
  public showPhoneDetailScreen: boolean = false;
  public showPhoneVoidScreen: boolean = false;
  public showInquiryScreen: boolean = false;
  public showQuickViewVoid: boolean = false;
  currentIndx: number;
  showAcc: boolean = false;
  deleteVoidSwitch: string = "";

  reference_number: string = " ";
  remarks: string = " ";

  payType: string;
  containerNum: string;
  txtArray2: string [] = [];
  subscription: Subscription;
  private clientRequest: ClientRequest;
  private contView: ContainerView;
  chargesBackBack: Charge[] = [];

  private contViewArray: ContainerView[] = [];
  private guaranteeArray: GuaranteesView[] = [];
  private contGuarArray: ContainerGuarantee[] = [];
  private workContGuarArray: ContainerGuarantee[] = [];
  private guarGuarArrayHist: GuaranteesView[] = [];
  private guaranteesView: GuaranteesView;
  private guarGuarArrayOtherHist: GuaranteesView[] = [];
  private contGuarArrayDisp: ContainerGuaranteeDisplay[] = [];
  private contGuarantee: ContainerGuarantee;
  private contGuaranteeDisplay: ContainerGuaranteeDisplay;
  public savedList: string;
  public savedLists: { id: string, code: string, description: string }[] = [];
  public redeliverList: { container: string, amount: number, amountwFee: number }[] = [];
  private listData: ListData[];
  private listDataObj: ListData;
  public insertNoConts: boolean = false; showCCMessage: boolean = false;
  public insertListExists: boolean = false;
  public debitCardUsed: boolean = false;
  public noListName: boolean = false;
  myNewListName: string = "";
  quickViewData: MatTableDataSource<ContainerView>;
  quickViewData2: MatTableDataSource<ContainerGuarantee>;
  quickViewData3: MatTableDataSource<GuaranteesView>;
  quickViewData4: MatTableDataSource<GuaranteesView>;
  quickViewData5: MatTableDataSource<GuaranteesView>;
  quickViewData6: MatTableDataSource<ContainerGuarantee>;

  private chargesExcelArray: ContainerViewChargesExcel[] = [];
  private chargesExcel: ContainerViewChargesExcel;

  chargeData: MatTableDataSource<Charge>;
  public qvColumns: string[];
  public qvColumnsIPad: string[];
  public currentCol: string[];
  public otherCol: string[];
  public voidCol: string[];
  public voidConfirm: string[];
  public qvColumns2: string[];
  public chargeColumns: string[];
  public errorColumn: string[];
  public dayColumn: string[];
  public dayCCColumn: string[];
  public histColumn: string[];
  private selection: SelectionModel<ContainerView>;
  private selection3: SelectionModel<GuaranteesView>;
  private workGuaranteesArray: GuaranteesView[];

  private selection2: SelectionModel<Charge>;
  private allChecked: boolean = false;
  private allRefsChecked: boolean = false;
  private allDatesChecked: boolean = false;
  private allRemarksChecked: boolean = false;
  private turnRed: boolean = false;
  noneSelected: boolean = false;
  ipadView: boolean = false;
  myForm: UntypedFormGroup;
  myForm2: UntypedFormGroup;
  private dateFilter: (date: Date, rowIn: GuaranteesView) => boolean;
  private end: string;
  private fteColName: string = "FTE Date";
  private refColName: string = "Ref#";
  @ViewChild('picker') dateInput: MatDatepicker<any>;
  private date1: Date;
  private startingDateString: string;
  private last_reference_number: string;
  private last_full_date: string;
  private last_end_date: string;
  private last_begin_date: string;
  private last_remark: string;
  public xMsg: string;
  private startingDateDate: Date;
  private foundOne: boolean = false;
  private last_range_mode: boolean = false;
  private number1: number;
  stateRegion: string;
  country: string;
  creditCard: string;
  month: string;
  year: string;
  workDate: Date;
  workDateasString: string;
  newStartDate: string;
  grandTotal: number;
  inquiryOnly: boolean = true;
  deadStopFound: boolean = false;
  showVoidConfirmationScreen: boolean = false;
  showSummaryScreen: boolean = false;
  showConfirmationScreen: boolean = false;
  totalFees: number; totalFeesVisa: number;
  workingTotal: number;
  workingTotalwFee: number; workingTotalwVisaFee: number;
  totalAmount: number;
  grandTotalDisp: string; creditCardEntered: boolean = false;
  maherError: string;
  grandTotalWFee: number;grandTotalWVisaFee: number;
  allDone: boolean = false;
  grandTotalWFeeDisp: string; grandTotalWFeeVisaDisp: string;
  totalFeesDisp: string; totalFeesVisaDisp: string;
  phoneApp: boolean = false;

  subTotalDisp: string;
  public stateRegions: { code: string, description: string }[] = [];
  public states: { code: string, description: string }[] = [];
  public regions: { code: string, description: string }[] = [];
  public countries: { code: string, description: string }[] = [];
  public cards: { code: string, description: string }[] = [];
  public months: { code: string, description: string }[] = [];
  public years: { code: string, description: string }[] = [];
  @ViewChild('stepper') private myStepper: MatStepper;
  @ViewChild('stepper2') private myStepper2: MatStepper;
  exists: boolean = false;
  processed: boolean = false;
  public today: Date = new Date();
  public today2: Date = new Date();
  public futureDay: Date = new Date();
  public futureDayDisp: String;
  tomorrow = new Date();
  checkCheckedMaher: boolean = false;
  checkCheckedLine: boolean = false;
  bothChecked: boolean = false; iCheckedLine: boolean = false; iCheckedMaher: boolean = false;

  private options3: { currencyDisplay: string; minimumFractionDigits: number; style: string; currency: string } = {style: 'currency', currency: 'USD', currencyDisplay: 'symbol', minimumFractionDigits: 2};


  @ViewChild(MatSort) set content(sort: MatSort) {

    if (this.quickViewData != undefined) {
      this.quickViewData.sort = sort;
    }


    if (this.quickViewData2 != undefined) {
      this.quickViewData2.sort = sort;
    }
    if (this.quickViewData3 != undefined) {
      this.quickViewData3.sort = sort;
    }
    if (this.quickViewData4 != undefined) {
      this.quickViewData4.sort = sort;
    }

  }

  @ViewChild(MatPaginator) set content3(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }

  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData4 != undefined) {
      this.quickViewData4.paginator = pag;
    }
  }


  @ViewChild(MatPaginator) paginator2: MatPaginator;

  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;


  private options4: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  private optionsFuture: Intl.DateTimeFormatOptions = {weekday: "long", month: "2-digit", day: "2-digit", year: "numeric"};
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  calendarDates: { date: string, payType: string, guarantee_type: string }[];
  takenDates: { date: string, container: string, event: string }[];
  workTakenDates: { date: string, container: string }[];
  private specificDatesForGuarantees: GuaranteesView[] = [];
  private rowInGArray: GuaranteesView[] = [];
  private chargeType: string;
  private currentContainer: string;
  private currentEvent: string;
  private startDateIndx: number;
  ccType: string;
  sub: any;




  exportExcel(fromWhere: string) {
    this.chargesExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++) {

      if (this.quickViewData.filteredData[xx].maherError == null  && this.quickViewData.filteredData[xx].navisErrors == null && this.quickViewData.filteredData[xx].charges.length > 0) {
        this.chargesExcel = {} as ContainerViewChargesExcel;
        this.chargesExcel.Container = this.quickViewData.filteredData[xx].container;
        this.chargesExcel.ISO = this.quickViewData.filteredData[xx].iso;
        this.chargesExcel.SSL = this.quickViewData.filteredData[xx].line_id;
        this.chargesExcel.VesselVoyage = this.quickViewData.filteredData[xx].vesselVoyage;
        if (fromWhere=="E"){
          this.chargesExcel.ChargeType = this.quickViewData.filteredData[xx].chargeDisplay;
        }else{
          this.chargesExcel.Category = this.quickViewData.filteredData[xx].category_description;
        }
        this.chargesExcel.DemurrageFTE = this.quickViewData.filteredData[xx].fte_date_fmt3;
        if (this.quickViewData.filteredData[xx].demurrageBalanceDue=="$0.00" || (this.quickViewData.filteredData[xx].chargeDisplay != null && this.quickViewData.filteredData[xx].chargeDisplay.toUpperCase().includes("EXAM"))) {
          this.chargesExcel.MaherDemurrage = " ";
          this.chargesExcel.LineDemurrage = " ";
          this.chargesExcel.TotalDemurrage = " ";
        }else{
          this.chargesExcel.MaherDemurrage = this.quickViewData.filteredData[xx].demurrageBalanceDueMaher;
          this.chargesExcel.LineDemurrage = this.quickViewData.filteredData[xx].demurrageBalanceDueLine;
          this.chargesExcel.TotalDemurrage = this.quickViewData.filteredData[xx].demurrageBalanceDue;
        }
        this.chargesExcel.PowerFTE = this.quickViewData.filteredData[xx].power_fte_date_fmt;
        if (this.quickViewData.filteredData[xx].powerDays=="0") {
          this.chargesExcel.PowerBal = " ";
        }else{
          this.chargesExcel.PowerBal = this.quickViewData.filteredData[xx].powerBalanceDue;
        }
        var tot = parseFloat(this.quickViewData.filteredData[xx].coastGuardExamChargesDue) + parseFloat(this.quickViewData.filteredData[xx].exportOffSiteExamChargesDue) + parseFloat(this.quickViewData.filteredData[xx].exportRedeliveryChargesDue) + parseFloat(this.quickViewData.filteredData[xx].shipSideExamChargesDue);
        if (tot>0){
          this.chargesExcel.ExamBal = this.getNiceCurrency(tot.toString());
        }

        if (fromWhere=="E"){
          if (this.quickViewData.filteredData[xx].charges.length>1){
            this.chargesExcel.ReferenceNumber = this.quickViewData.filteredData[xx].charges[0].reference_number;
            this.chargesExcel.Remarks = this.quickViewData.filteredData[xx].charges[0].remarks;
          }else{
            this.chargesExcel.ReferenceNumber = this.quickViewData.filteredData[xx].reference_number;
            this.chargesExcel.Remarks = this.quickViewData.filteredData[xx].remarks;
          }


        }
        this.chargesExcel.Total = this.quickViewData.filteredData[xx].totalAmount;
        if (this.chargesExcel.Total != null) {
          this.chargesExcel.Total = this.getNiceCurrency(this.chargesExcel.Total);
        }

        this.chargesExcelArray.push(this.chargesExcel);
      }
    }



    const workSheet = XLSX.utils.json_to_sheet(this.chargesExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:10},
      {wch:10},
      {wch:30},
      {wch:15},
      {wch:13},
      {wch:15},
      {wch:32},
      {wch:13},
      {wch:13},
      {wch:13},
      {wch:17},
      {wch:30},
      {wch:13},

    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'ContainerCharges');
    XLSX.writeFile(workBook, 'containerCharges.xlsx');
  }

  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService,private  globalEventsManager: GlobalEventsManager, private myApp: AppComponent, private queryService: QueryService) {

    this.myForm = fb.group({
      name: ['', [Validators.pattern('^[a-zA-Z ]*$'), Validators.required]],
      address: ['', [Validators.pattern('^[a-zA-Z0-9 ]*$'), Validators.required]],
      address2: ['', [Validators.pattern('^[a-zA-Z0-9 ]*$')]],
      city: ['', [Validators.pattern('^[a-zA-Z ]*$'), Validators.required]],
      zip: ['', [Validators.pattern('[a-zA-Z0-9 ]{5,}'), Validators.required]],
      email: ['', [Validators.pattern('^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}$'), Validators.required]],
    });

    this.sub = this.service.getConfirmed().subscribe((value) => {
      if (value) {
        if (this.deleteVoidSwitch == "V") {
          this.voidPayments();
        } else {
          this.updateContainerList('D');
        }
        this.service.setConfirmed(false);
      }
    });


    this.qvColumns = ["check", "container", "line_id", "category_description", "vesselVoyage", "booking", "chargeDisplay", "fte_date_fmt", "gDate", "reference_number", "remarks","totalAmountMaher","totalAmountLine", "totalAmountWithFee"];
    this.qvColumnsIPad = ["check", "container", "line_id", "category_description", "chargeDisplay", "fte_date_fmt", "gDate", "reference_number", "remarks", "totalAmountWithFee"];
    this.currentCol = ["guarantee_amount_disp", "totalFeesDisp", "totalAmountDisp", "eventTypeDisp", "guarantee_start_day", "guarantee_end_day", "customer_reference_id", "guarantee_id", "n4_user_id", "created", "voided_or_expired_date_disp"];
    this.otherCol = ["eventTypeDisp", "guarantee_start_day", "guarantee_end_day", "created", "voided_or_expired_date"];
    this.voidCol = ["id", "voided_or_expired_date_disp", "sslDisp", "vesselVoyageDisp", "category_description", "event_type_description", "guarantee_start_day", "guarantee_end_day", "guarantee_amount", "check2"];
    this.voidConfirm = ["status", "guarantee_id", "id", "event_type_description", "guarantee_start_day", "guarantee_end_day", "totalAmountDisp"];
    this.chargeColumns = ["check", "type", "typeDescription", "fte_date_fmt", "gDate", "reference_number", "remarks","amoutMaher","amoutLine", "amout"];
    this.errorColumn = ["error"];
    this.dayColumn = ["status", "guaranteeID", "container", "chargeEvent", "fromDate", "toDate", "totalAmountMaherDisp","totalAmountLineDisp", "totalAmountDisp"];
    this.dayCCColumn = ["status", "guaranteeID", "container", "chargeEvent", "fromDate", "toDate", "creditCardAuthorizationID","totalAmountMaherDisp","totalAmountLineDisp", "totalAmountDisp", "totalFeesDisp", "grandTotalAmountDisp"];
    this.histColumn = ["id", "event_type_description", "guarantee_start_day", "guarantee_end_day", "created", "voided_or_expired_date_disp"];
    this.qvColumns2 = ["container", "line_description", "vesselVoyage", "category_description","demurrageBalanceDueMaher","demurrageBalanceDueLine", "demurrageBalanceDue", "powerBalanceDue", "examTotal"];

    this.tomorrow.setDate(this.tomorrow.getDate() + 1);

    this.myForm2 = fb.group({
      ccNum: ['', [Validators.pattern('^[0-9]*$'), Validators.required]],
      secCode: ['', [Validators.pattern('^[0-9]*$'), Validators.required]]
    });

    this.dateFilter = (date: Date, rowIn: GuaranteesView) => {

      this.calendarDates = null;
      this.calendarDates = [];

      let workDate = this.getNiceDateTimeForDate2(date);
  //    let workDate = moment(date).format("YYYY-MM-DD");


      if (this.specificDatesForGuarantees == undefined || this.specificDatesForGuarantees.length == 0) {
        return true;
      }

      var indx = this.specificDatesForGuarantees.findIndex(xx => Date.parse(xx.guarantee_start_day) == Date.parse(workDate) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
      if (indx != -1) {
        this.startDateIndx = indx;
        this.calendarDates.push({"date": date.getDate().toString(), "payType": this.specificDatesForGuarantees[indx].payment_type, "guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type });
      /*  if (this.takenDates.findIndex(xx => xx.date == workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) == -1) {
          this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
        }*/
        return false;
      }

      indx = this.specificDatesForGuarantees.findIndex(xx => Date.parse(xx.guarantee_end_day) == Date.parse(workDate) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
      if (indx != -1) {
        this.calendarDates.push({
          "date": date.getDate().toString(),
          "payType": this.specificDatesForGuarantees[indx].payment_type,
          "guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type
        });
     /*   if (this.takenDates.findIndex(xx => xx.date == workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) == -1) {
          this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
        }*/
        return false;
      } else {
        indx = this.specificDatesForGuarantees.findIndex(xx => (Date.parse(workDate) >= Date.parse(xx.guarantee_start_day) && Date.parse(workDate) <= Date.parse(xx.guarantee_end_day)) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
        if (indx != -1) {
          this.calendarDates.push({
            "date": date.getDate().toString(),
            "payType": this.specificDatesForGuarantees[indx].payment_type,
            "guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type
          });
     /*     if (this.takenDates.findIndex(xx => xx.date == workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) == -1) {
            this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
          }*/
          return false;
        }
        /*
        if (this.startDateIndx != null) {
          var from = Date.parse(this.specificDatesForGuarantees[this.startDateIndx].guarantee_start_day);
          var to = Date.parse(this.specificDatesForGuarantees[this.startDateIndx].guarantee_end_day);
          var dateCheck = Date.parse(workDate);
          if ((dateCheck >= from && dateCheck <= to)) {
            this.calendarDates.push({
              "date": date.getDate().toString(),
              "payType": this.specificDatesForGuarantees[this.startDateIndx].payment_type
            });
            return false;


         */
      }


      if (workDate >= this.startingDateString && !!this.foundOne) {
        this.foundOne = true;
        this.startingDateDate = this.getNiceDate3(workDate);
      }

      return true;
    }

    this.myUser = this.myApp.user;
    this.service.myUser = this.myUser;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = " ";
    this.myUser.credit_status = "OAC";
    this.myUser.company_code = "EGN"
    this.myUser.company_code = "M0995"
    this.myUser.company_name = "MAHER TERMINALS, LLC"
    this.myUser.city = "HOUSTON"
    this.myUser.email_address = "miller@maherterminals.com"
    this.myUser.fax_number = null
    this.myUser.first_name = "Csp Craig"
    this.myUser.last_name = "Miller"
    this.myUser.maherError = null
    this.myUser.old_password = null
    this.myUser.password = ""
    this.myUser.phone_number = null
    this.myUser.company_scac = null
    this.myUser.state = "TX"
    this.myUser.userMenuReportItemsView = null
    this.myUser.user_gkey = "8237887"
 //      this.myUser.role= "HAULIER"
  //  this.myUser.role= "LINEOP"
   this.myUser.role = "AGENT"
          this.myUser.username = "CSPSSL";
    this.myUser.username = "CSPTRUCKERLUCY";
   this.myUser.username = "CDOUG";

    this.myUser.menuRoleArray = [];
    this.myUser.menuRoleArray[0] = "CSP_CONSIGNEE_ROLE";
    this.myUser.zip = "07201"
    this.myUser.creditCard = {} as CreditCard;
    this.myUser.canSeeAllData = "1";
    this.myUser.callingCalculator = "Y";
    this.service.myUser = this.myUser;



 */





  }

  isConsignee(): boolean{
    if (this.myUser.company_code=="C3262"){
      return true;
    }else{
      return false;
    }
  }


  fillUpSavedLists() {
    this.savedLists = [];
    for (var item of this.listData) {
      if (item.type == "E") {
        this.savedLists.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists.length > 0) {
      this.savedList = this.savedLists[0].id;
    }
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get f() {
    return this.myForm.controls;
  }

  get g() {
    return this.myForm2.controls;
  }



  getCorrectCols(): string[] {
    if (this.payType == "C") {
      return this.dayCCColumn;
    } else {
      return this.dayColumn;
    }
  }

  getipadCols(): string[] {
    if (window.innerWidth <1050){
      return this.qvColumnsIPad;
    } else {
      return this.qvColumns;
    }
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  returnToQuickView() {
    this.showQuickView2 = true;
    this.showDetailScreen = false;
  }

  voidButtonHit() {



    this.submitted = true;
    this.nothingSelected = false;
    if (this.selection3.isEmpty()) {
      this.nothingSelected = true;
      return;
    }
    if (window.innerWidth <750){
      window.scrollTo(0, 0);
    }

    this.deleteVoidSwitch = "V";
    this.myApp.showConfirmBanner("Confirm", "confirm void", "importCharges");
    return;
  }


  showDetails(rowIn: ContainerView) {
    if (rowIn.maherError != null || rowIn.navisErrors != null) {
      return;
    }
    this.currentIndx = this.contViewArray.findIndex(xx => xx.container == rowIn.container);
    //  this.currHistory.sort(function(a, b) {
    //   return Number.parseInt(b.guara) - Number.parseInt(a.unit_gkey)
    //  });

    // this.quickViewData2 = new MatTableDataSource<ContainerView>(this.historyView);
    this.showQuickView2 = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.contView = null;
    this.contView = {} as ContainerView;
    this.contView = this.contViewArray[this.currentIndx];
    this.guarGuarArrayHist = [];
    this.guarGuarArrayOtherHist = [];

    if (rowIn.demurrageBalanceDueLine==null || rowIn.demurrageBalanceDueLine.includes("Contact Line")){
      this.foundStorageSSL = false;
    }else{
      this.foundStorageSSL = true;
    }

    if (this.myUser.role == "SHIPPER") {
      this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code && xx.n4_user_id == this.myUser.username);
      this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code || (xx.guarantor == this.myUser.company_code && xx.n4_user_id != this.myUser.username));
    } else {
      this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code);
      this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code);
    }


    this.formatDetailScreen();
    this.quickViewData3 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayHist);
    this.quickViewData4 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayOtherHist);

  }


  setupRow(rowIn: any, typeIn: string, startIn: Date) {
    this.rowInGArray = [];
    if (rowIn != null) {
      this.chargeType = typeIn;
      this.currentEvent = typeIn;
      var indx = this.contViewArray.findIndex(xx => xx.iufv_gkey == rowIn.iufv_gkey);
      if (indx != -1) {
        this.rowInGArray = this.contViewArray[indx].guaranteesArray;
      }
      if (this.rowInGArray.length > 0) {
        this.currentContainer = this.rowInGArray[0].id;
      }

      this.startDateIndx = null;
      this.specificDatesForGuarantees = null;
      this.specificDatesForGuarantees = [];
      this.specificDatesForGuarantees = {} as GuaranteesView[];
      this.specificDatesForGuarantees = Object.assign([], this.rowInGArray);

      this.foundOne = false;
      if (startIn != null) {
        this.startingDateString = this.getNiceDateTimeForDate2(startIn);
      }
    }


  }




  onOpen() {
    this.appendFooter();
  }

  private appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }

  dateClass() {
    return (date: Date): MatCalendarCellCssClasses => {
      if (this.calendarDates!=null){
        var indx = this.calendarDates.findIndex(xx => xx.date == date.getDate().toString());
        if (indx != -1) {
          if (this.calendarDates[indx].guarantee_type == "CREDIT_PREAUTHORIZE") {
            return 'creditCard';
          } else if (this.calendarDates[indx].guarantee_type == "WAIVER") {
            return 'waived';
          } else if (this.calendarDates[indx].guarantee_type == "PAID" || this.calendarDates[indx].guarantee_type == "PRE_PAY" || this.calendarDates[indx].guarantee_type == "STPAID") {
            return 'cash';
          } else if (this.calendarDates[indx].guarantee_type == "OAC") {
            return 'guarantee';
          }
        }
      }

    }
  }


  typedDate(row: ContainerView){
    if (row.full_date!=null){
      if ((!this.checkIfDateIsGoodForDuplicate(row, row.charges[0].type)) || (Date.parse(row.end_date_in) < Date.parse(row.start_date_in))){
        row.nothingGood = true;
        if ((Date.parse(row.end_date_in) < Date.parse(row.full_date.begin))){
          this.xMsg = "Invalid: Reverse Date";
          return;
        }else{
          this.xMsg = "Invalid: Date Overlap";
        }
        this.last_full_date = row.full_date;
        this.last_begin_date = row.start_date_in;
        this.last_end_date = row.end_date_in;
      }else{
        row.nothingGood = false;
      }
    }else{
      row.nothingGood = false;
    }

  }

  showTheDateField(row: ContainerView): boolean{
    if ((row.charges.length==1 && row.charges[0].flatRate=='Y') || row.freight_kind=='MTY' ||  row.charges.length==0 || row.charges.length>1 || row.maherError!=null || (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER')))){
      return false;
    }else{
      return true;
    }

  }

  showTheDateFieldCharges(row: Charge): boolean{
    if (row.type!=null && (row.type.toUpperCase().includes('EXAM') && !row.type.toUpperCase().includes('REDELIVER')) || row.flatRate=='Y'){
        return false;
    }else{
        return true;
    }
  }

  typedDateCharge(row: Charge, typeIn: string, contviewRecord: ContainerView){
    if (row.full_date!=null){

      if ((!this.checkIfDateIsGoodForDuplicate(contviewRecord, typeIn)) || (row.full_date.end < row.full_date.begin)){
        row.nothingGood = true;
        if ((row.full_date.end < row.full_date.begin)){
          this.xMsg = "Invalid: Reverse Date";
          return;
        }else{
          this.xMsg = "Invalid: Date Overlap";
        }
        this.last_full_date = row.full_date;
        this.last_begin_date = row.start_date_in;
        this.last_end_date = row.end_date_in;
      }else{
        row.nothingGood = false;
      }
    }else{
      row.nothingGood = false;
    }

  }


  emitDates(ref, rowIn: ContainerView, selected: boolean) {
    if (rowIn.chargeDisplay!=null && rowIn.chargeDisplay.toUpperCase().includes("REDELIVERY")){
      rowIn.end_date_in = rowIn.start_date_in;
      rowIn.full_date = rowIn.start_date_in;
    }else{
      if (rowIn.start_date_in!=undefined && rowIn.end_date_in!=undefined){
        rowIn.full_date = rowIn.start_date_in + " - " + rowIn.end_date_in;
      }
    }
    this.last_range_mode = rowIn.rangeMode;
    rowIn.nothingGood = false;
    if (rowIn.full_date != null) {
      if (( Date.parse(rowIn.end_date_in)<  Date.parse(rowIn.start_date_in))){
        return;
      }
      this.last_full_date = rowIn.full_date;
      this.last_begin_date = rowIn.start_date_in;
      this.last_end_date = rowIn.end_date_in;
    } else {
     // rowIn.start_date_in = null;
   //   rowIn.end_date_in = null;
    }


    if (rowIn.reference_number != null && rowIn.reference_number != "" && rowIn.reference_number!=" ") {
      return;
    } else {
      if (rowIn.full_date == null || rowIn.full_date == "") {
        this.selection.deselect(rowIn);
      } else {
        this.selection.select(rowIn);
      }
    }
    this.turnOnButtonCheck();

  }

  emitDatesCharges(ref, rowIn: Charge, selected: boolean) {
    if (rowIn.typeDescription!=null && rowIn.typeDescription.toUpperCase().includes("REDELIVERY")){
      rowIn.end_date_in = rowIn.start_date_in;
      rowIn.full_date = rowIn.start_date_in;
    }else{
      if (rowIn.start_date_in!=undefined && rowIn.end_date_in!=undefined){
        rowIn.full_date = rowIn.start_date_in + " - " + rowIn.end_date_in;
      }
    }

    if (rowIn.end_date_in!="" && rowIn.end_date_in!=null){
      rowIn.full_date = rowIn.start_date_in + " - " + rowIn.end_date_in;
    }else{
      rowIn.full_date = rowIn.start_date_in;
    }
    this.last_range_mode = rowIn.rangeMode;

    rowIn.nothingGood = false;
    if (rowIn.full_date != null) {

      if (( Date.parse(rowIn.end_date_in)<  Date.parse(rowIn.start_date_in))){
        return;
      }

      this.last_full_date = rowIn.full_date;
      this.last_begin_date = rowIn.start_date_in;
      this.last_end_date = rowIn.end_date_in;
    } else {
      rowIn.start_date_in = null;
      rowIn.end_date_in = null;
    }



    if (rowIn.reference_number != null && rowIn.reference_number != "" && rowIn.reference_number!=" ") {
      return;
    } else {
      if (rowIn.full_date == null || rowIn.full_date == "") {
        this.selection2.deselect(rowIn);
      } else {
        this.selection2.select(rowIn);
      }
    }
    this.turnOnButtonCheck();
  }

  makeSelected(rowIn: ContainerView, selected: boolean) {
    this.last_reference_number = rowIn.reference_number;
    if (rowIn.full_date != null) {
      return;
    } else {
      if (rowIn.reference_number == null || rowIn.reference_number == "" || rowIn.reference_number==" ") {
        this.selection.deselect(rowIn);
        this.last_reference_number = null;
      } else {
        this.selection.select(rowIn);
      }
    }
    this.turnOnButtonCheck();

  }






  makeSelectedCharges(rowIn: Charge, selected: boolean) {
    this.last_reference_number = rowIn.reference_number;
    if (rowIn.full_date != null) {
      return;
    } else {
      if (rowIn.reference_number == null || rowIn.reference_number == "" || rowIn.reference_number==" ") {
        this.selection2.deselect(rowIn);
        this.last_reference_number = null;
      } else {
        this.selection2.select(rowIn);
      }
    }
    this.turnOnButtonCheck();
  }

  ngOnInit() {
    this.search1 = new UntypedFormControl();
    this.selection = null;
    this.selection = new SelectionModel<ContainerView>(true);
    this.selection2 = new SelectionModel<Charge>(true);
    this.selection3 = new SelectionModel<GuaranteesView>(true);
    this.getListData();
    this.service.getAllSslStorageCollections(this.myUser);
    this.countries = this.service.getCountries();
    this.states = this.service.getStates();
    this.regions = this.service.getRegions();
    this.cards = this.service.getCards();
    this.months = this.service.getMonths();
    this.years = this.service.getYears();
    this.stateRegions = this.states;
    this.country = this.countries[0].code;
    this.stateRegion = this.stateRegions[0].code;
    this.creditCard = this.cards[0].code;
    this.month = this.months[0].code;
    this.year = this.years[0].code;

    this.checkMenuRoles();
    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadView = true;
      this.fteColName = "FTE";
      this.refColName = "Ref#"
    }else{
      this.fteColName = "FTE Date";
      this.refColName = "Ref#"
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }

  }



  returnToSearch(){
    this.resetScreen();

    if (this.ipadView){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }



  checkMenuRoles() {
    for (var item of this.myUser.menuRoleArray) {
      if ((item.toUpperCase().includes("ENTRY")) || (item.toUpperCase() == "CSP_CONSIGNEE_ROLE") || (item.toUpperCase() == "CSP_ALL_DATA")  || (item.toUpperCase()=="CSP_ALL_MENUS") ) {
        this.inquiryOnly = false;
        this.screenMode = "E";
      }
    }
  }

  checkForOverlapDates() {
    this.workContGuarArray = [];
    for (var items of this.contGuarArray) {
      if (!items.typeOfCharge.toUpperCase().includes("EXAM")) {
        if ((items.fromDate == items.toDate) || items.isFlatRate == "Y") {
          continue;
        } else {
          var originalEndDate, stillGoing = true, firstTime = true;
          this.workDateasString = items.fromDate;
          originalEndDate = items.toDate;
          while (stillGoing) {


            var indx = this.quickViewData.data.findIndex(xx => xx.iufv_gkey == items.iufv_gkey);
            if (indx != -1) {
              if (this.takenDates.findIndex(xx => xx.date == this.workDateasString && xx.container == items.container && xx.event == items.typeOfCharge) == -1) { //date doesnt exist on table -work with it
                this.workTakenDates = this.takenDates.filter(xx => (Date.parse(xx.date) > Date.parse(this.workDateasString) && Date.parse(xx.date) < Date.parse(originalEndDate)) && xx.container == items.container && xx.event == items.typeOfCharge)
                if (this.workTakenDates.length > 0) {
                  if (firstTime) {
                    this.workDate = this.getNiceDate3(this.workTakenDates[0].date);
                    this.workDate.setDate(this.workDate.getDate() - 1); //adding 1 to the toDate
                    this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
                    items.toDate = this.getNiceDateTimeForDate2(this.workDate);
                    firstTime = false;
                  } else {
                    this.contGuarantee = null;
                    this.contGuarantee = Object.assign({}, items); //clone the original record
                    this.contGuarantee.fromDate = this.workDateasString;
                    this.workDate = this.getNiceDate3(this.workTakenDates[0].date);
                    this.workDate.setDate(this.workDate.getDate() - 1); //adding 1 to the toDate
                    this.contGuarantee.toDate = this.getNiceDateTimeForDate2(this.workDate);
                    this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
                    this.workContGuarArray.push(this.contGuarantee);
                  }
                } else {
                  if (!firstTime) {
                    this.contGuarantee = null;
                    this.contGuarantee = Object.assign({}, items); //clone the original record
                    this.contGuarantee.fromDate = this.workDateasString;
                    this.contGuarantee.toDate = originalEndDate;
                    this.workContGuarArray.push(this.contGuarantee);
                  }
                  stillGoing = false;
                  break;
                }
              }
              this.workDate = this.getNiceDate3(this.workDateasString);
              this.workDate.setDate(this.workDate.getDate() + 1); //adding 1 to the toDate
              this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
            }
          }
        }
      }
    }

    for (var things of this.workContGuarArray) {
      this.contGuarArray.push(things);
    }


  }


  verifySelectionPhone(){
    window.scrollTo(0, 0);
    for (var items of this.contView.charges){
      if (items.remarks!=null || items.reference_number!=null || (items.full_date!=null && items.full_date!=" ")){
        this.selection2.select(items);
      }
    }
    this.verifySelection();
  }


  verifySelection() {


    if (this.oneIsInAlready){
      return;
    }

    this.submitted = true;
    this.oneIsInAlready = true;
    this.myForm.reset();
    this.nothingSelected = false;
    this.missingDate = false;
    this.missingRef = false;
    this.redeliverRecord = false;
    this.missingBoth = false;
    this.containerOut = null;
    this.badChars = false;
    this.badRemarks = false;

    if (this.selection.isEmpty() && this.selection2.isEmpty()) {
      this.nothingSelected = true;
      this.oneIsInAlready = false;
      return;
    }

    for (var sel of this.selection.selected) {
      if (sel.nothingGood){
        this.containerOut = sel.container;
        this.badDate = true;
        this.oneIsInAlready = false;
        return;
      }

      for (var sel2 of this.selection2.selected) {
        if (sel2.nothingGood) {
          this.containerOut = sel2.container;
          this.badDate = true;
          this.oneIsInAlready = false;
          return;
        }
      }

      if ((sel.chargeDisplay!=null && (!sel.chargeDisplay.toUpperCase().includes("EXAM") || sel.chargeDisplay.toUpperCase().includes("REDELIVER")))) {
        if (sel.charges.length == 1 && sel.charges[0].flatRate == 'Y') {
        } else {
          if (sel.start_date_in == null || sel.start_date_in == "") {
            this.containerOut = sel.container;
            this.missingDate = true;
          }
        }
      }
      if (sel.reference_number == null || sel.reference_number == "" || sel.reference_number==" ") {
        this.containerOut = sel.container;
        this.missingRef = true;
      }
      if (!this.service.checkForSpecialChars(sel.reference_number)) {
        this.containerOut = sel.container;
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }
      if (!this.service.checkForSpecialChars(sel.remarks)) {
        this.containerOut = sel.container;
        this.badRemarks = true;
        this.oneIsInAlready = false;
        return;
      }
    }

    for (var sel2 of this.selection2.selected) {
      if (sel2.nothingGood){
        this.containerOut = sel2.container;
        this.badDate = true;
        this.oneIsInAlready = false;
        return;
      }
      if ((sel2.type!=null && !sel2.type.toUpperCase().includes("EXAM"))) {
        if (sel2.flatRate == 'N') {
          if (sel2.start_date_in == null || sel2.start_date_in == "") {
            this.containerOut = sel2.container;
            this.typeOut = sel2.typeDescription;
            this.missingDate = true;
          }
        }
      }
      if (sel2.reference_number == null || sel2.reference_number == "" || sel2.reference_number == " ") {
        this.containerOut = sel2.container;
        this.typeOut = sel2.typeDescription;

        this.missingRef = true;

      }
      if (!this.service.checkForSpecialChars(sel2.reference_number)) {
        this.containerOut = sel2.container;
        this.typeOut = sel2.typeDescription;

        this.badChars = true;
        this.oneIsInAlready = false;

        return;
      }
      if (!this.service.checkForSpecialChars(sel2.remarks)) {
        this.containerOut = sel2.container;
        this.typeOut = sel2.typeDescription;

        this.badRemarks = true;
        this.oneIsInAlready = false;

        return;
      }
    }

    if (this.missingDate && this.missingRef) {
      this.missingRef = false;
      this.missingDate = false;
      this.missingBoth = true;
      this.oneIsInAlready = false;
      return;
    } else if (this.missingDate) {
      this.oneIsInAlready = false;
      return;
    } else if (this.missingRef) {
      this.oneIsInAlready = false;
      return;
    }

    this.contGuarArray = null;
    this.contGuarArray = [];
    for (var items of this.selection.selected) {
      this.contGuarantee = {} as ContainerGuarantee;
      this.contGuarantee.apiGkey = items.apiGkey;
      this.contGuarantee.iufv_gkey = items.iufv_gkey;
      this.contGuarantee.extractGkey = items.charges[0].extractGkey;
      this.contGuarantee.category = items.category;
      this.contGuarantee.container = items.container;
      this.contGuarantee.iso_description = items.iso_description;
      this.contGuarantee.received_date_fmt = items.received_date_fmt;
      this.contGuarantee.fte_date_fmt = items.fte_date_fmt;
      this.contGuarantee.in_vessel_description = items.in_vessel_description;
      this.contGuarantee.in_voyage = items.in_voyage;
      this.contGuarantee.line_description = items.line_description;
      this.contGuarantee.port_of_discharge_description = items.port_of_discharge_description;
      this.contGuarantee.free_days = items.free_days;


      this.contGuarantee.isFlatRate = "N";
      if ((items.chargeDisplay!=null && (items.chargeDisplay.toUpperCase().includes("EXAM") && !items.chargeDisplay.toUpperCase().includes("REDELIVER"))) || (items.charges.length == 1 && items.charges[0].flatRate == 'Y')) {
        this.contGuarantee.fromDate = null;
        this.contGuarantee.toDate = null;
        this.contGuarantee.isExam = "Y";
        if (items.charges.length >0){
          this.contGuarantee.typeOfCharge = items.charges[0].type;
        }
        if ((items.charges.length == 1 && items.charges[0].flatRate == 'Y')) {
          this.contGuarantee.isFlatRate = "Y";
          this.contGuarantee.totalAmount = items.charges[0].amout;
          this.contGuarantee.totalFees = items.charges[0].totalFees;
          this.contGuarantee.totalAmountWithFee = items.charges[0].totalAmountWithFee;
          this.contGuarantee.typeOfCharge = items.charges[0].type;

        }
      } else {
        if (items.chargeDisplay!=null && items.chargeDisplay.toUpperCase().includes("REDELIVER")) {
          if (items.received_date != null) {
            this.contGuarantee.fromDate = this.getNiceDate(items.received_date);
          }
        } else {
          if (items.start_date_in != null) {
            this.contGuarantee.fromDate = this.getNiceDate(items.start_date_in);
          }
        }
        if (items.charges.length >0){
          this.contGuarantee.typeOfCharge = items.charges[0].type;

        }

        this.contGuarantee.isExam = "N";
        if (items.end_date_in != null) {
          this.contGuarantee.toDate = this.getNiceDate(items.end_date_in);
        }else{
          this.contGuarantee.toDate = this.getNiceDate(items.start_date_in);
        }
      }
      this.contGuarantee.guaranteeType = this.payType;
      this.contGuarantee.line_id = items.line_id;
      this.contGuarantee.reference = items.reference_number;
      this.contGuarantee.remarks = items.remarks;
      this.contGuarArray.push(this.contGuarantee);
      if (items.chargeDisplay!=null && items.chargeDisplay.toUpperCase().includes("REDELIVERY")) {
        this.redeliverRecord = true;
        this.getMoreCharges(items);
      }
    }

    for (var items2 of this.selection2.selected) {
      this.contGuarantee = {} as ContainerGuarantee;
      this.contGuarantee.apiGkey = items2.apiGkey;
      this.contGuarantee.iufv_gkey = items2.iufv_gkey;
      this.contGuarantee.isFlatRate = "N";
      this.contGuarantee.typeOfCharge = items2.type;

      var indx = this.quickViewData.data.findIndex(xx => xx.iufv_gkey == items2.iufv_gkey);
      if (indx != -1) {
        this.contView = this.quickViewData.data[indx];
        this.contGuarantee.category = this.quickViewData.data[indx].category;
        this.contGuarantee.iso_description = this.quickViewData.data[indx].iso_description
        this.contGuarantee.received_date_fmt = this.quickViewData.data[indx].received_date_fmt;
        this.contGuarantee.fte_date_fmt = this.quickViewData.data[indx].fte_date_fmt;
        this.contGuarantee.in_vessel_description = this.quickViewData.data[indx].in_vessel_description;
        this.contGuarantee.in_voyage = this.quickViewData.data[indx].in_voyage;
        this.contGuarantee.line_description = this.quickViewData.data[indx].line_description;
        this.contGuarantee.port_of_discharge_description = this.quickViewData.data[indx].port_of_discharge_description;
        this.contGuarantee.free_days = this.quickViewData.data[indx].free_days;

      }

      this.contGuarantee.extractGkey = items2.extractGkey;
      this.contGuarantee.container = items2.container;
      if ((items2.type!=null && (items2.type.toUpperCase().includes("EXAM") && !items2.type.toUpperCase().includes("REDELIVER"))) || items2.flatRate == 'Y') {
        this.contGuarantee.fromDate = null;
        this.contGuarantee.toDate = null;
        this.contGuarantee.isExam = "Y";
        if (items2.flatRate == 'Y') {
          this.contGuarantee.isFlatRate = "Y";
          this.contGuarantee.totalAmount = items2.amout;
          this.contGuarantee.totalFees = items2.totalFees;
          this.contGuarantee.totalAmountWithFee = items2.totalAmountWithFee;
        }
      } else {
        this.contGuarantee.isExam = "N";
        if (items2.type!=null && items2.type.toUpperCase().includes("REDELIVERY")) {
        }

          if (items2.start_date_in != null) {
          this.contGuarantee.fromDate = this.getNiceDate(items2.start_date_in);
        }
      }
      this.holdDate = null;
      if (items2.end_date_in != null) {
        this.contGuarantee.toDate = this.getNiceDate(items2.end_date_in);
      }
      this.contGuarantee.guaranteeType = this.payType;
      this.contGuarantee.line_id = items2.line_id;
      this.contGuarantee.reference = items2.reference_number;
      this.contGuarantee.remarks = items2.remarks;
      this.contGuarArray.push(this.contGuarantee);
      if (items2.type!=null && items2.type.toUpperCase().includes("REDELIVERY")) {
        this.holdDate = this.contGuarantee.toDate;
        this.redeliverRecord = true;
        this.getMoreCharges(this.contView);
      }
    }


   this.checkForOverlapDates();


    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.contGuarArray;
    const lhsUserObs$ = this.queryService.paymentCalculateDates(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (datesBack) => {
        this.contGuarArray = datesBack;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.submitted = false;
        this.oneIsInAlready = false;
        this.contGuaranteeDisplay = null;
        this.deadStopFound = false;
        this.contGuarArrayDisp = [];
        this.grandTotal = 0;
        this.grandTotalWFee = 0;
        this.grandTotalWVisaFee = 0;
        this.totalFees = 0;
        this.totalFeesVisa = 0;
        this.totalAmount = 0;
        this.workingTotalwFee = 0;
        this.workingTotalwVisaFee = 0;
        this.workingTotal = 0;

        this.redeliverList = [];

        this.contGuarArray.sort(function(a, b) {
          if (a.container < b.container) {
            return -1;
          }
          if (a.container > b.container) {
            return 1;
          }
          return 0;
        })

        if (window.innerWidth < 750){
          this.showSummaryScreen = true;
          this.showPhoneDetailScreen = false;
        }

        this.maherError = null;
        for (var tt of this.contGuarArray) {
          if (tt.maherError != null) {
            this.maherError = tt.maherError;
            this.deadStopFound = true;
            this.submitted = true;
          }else if (tt.navisErrors!=null){
            this.maherError = tt.navisErrors[0];
            this.deadStopFound = true;
          } else {
            this.contGuaranteeDisplay = {} as ContainerGuaranteeDisplay;
            this.contGuaranteeDisplay.chargeDates = [];
            this.contGuaranteeDisplay.totalAmount = "0";
            this.contGuaranteeDisplay.totalAmountWithFee = "0";
            this.contGuaranteeDisplay.totalAmountWithFeeVisa = "0";
            this.contGuaranteeDisplay.totalFees = "0";
            this.contGuaranteeDisplay.totalFeesVisa = "0";
            indx = this.contGuarArrayDisp.findIndex(xx => xx.container == tt.container);
            if (indx != -1) {
              this.contGuaranteeDisplay.container = " ";
            } else {
              this.contGuaranteeDisplay.container = tt.container;
            }

            var indx = this.quickViewData.data.findIndex(xx => xx.iufv_gkey == tt.iufv_gkey);
            if (indx != -1) {

              var indx2 = this.quickViewData.data[indx].charges.findIndex(yy => yy.extractGkey == tt.extractGkey);
              if (indx2 != -1) {
                this.contGuaranteeDisplay.chargeEvent = this.quickViewData.data[indx].charges[this.quickViewData.data[indx].charges.findIndex(yy => yy.extractGkey == tt.extractGkey)].typeDescription;
              } else {
                if (tt.typeOfCharge!=null){
                  if (tt.typeOfCharge.toUpperCase()=="STORAGE"){
                    this.contGuaranteeDisplay.chargeEvent = "Demurrage";
                  }else if (tt.typeOfCharge.toUpperCase()=="REEFER"){
                    this.contGuaranteeDisplay.chargeEvent = "Power";
                  }else{
                    this.contGuaranteeDisplay.chargeEvent = " ";

                  }

                }
              }
            }

            var sIn
            if (tt.fromDate != null) {
             if (this.contGuaranteeDisplay.chargeEvent!=null && this.contGuaranteeDisplay.chargeEvent.toUpperCase().includes("REDELIVERY")) {
                sIn =  "For Pick-up on: " + tt.toDate;
              }else{
                sIn = tt.fromDate + " - " + tt.toDate;
              }
              this.contGuaranteeDisplay.chargeDates.push({"description": sIn});
            } else {
              this.contGuaranteeDisplay.chargeDates = [];
            }
            this.contGuaranteeDisplay.totalAmountMaher = this.getNiceCurrency(tt.totalAmountMaher);
            if (tt.totalAmountLine!="0.0"){
              this.contGuaranteeDisplay.totalAmountLine = this.getNiceCurrency(tt.totalAmountLine);

            }

            var cDue, cDueWFee, xxx, reDelTot, cDueWVisaFee, reDelTotVisa;
            if (this.contGuaranteeDisplay.chargeEvent!=null && this.contGuaranteeDisplay.chargeEvent.toUpperCase().includes("COAST")) {
              cDue = this.quickViewData.data[indx].coastGuardExamChargesDue;
              cDueWFee = this.quickViewData.data[indx].coastGuardExamChargesDueWithFee;
              cDueWVisaFee = this.quickViewData.data[indx].coastGuardExamChargesDueWithVisaFee;
            } else if (this.contGuaranteeDisplay.chargeEvent!=null && this.contGuaranteeDisplay.chargeEvent.toUpperCase().includes("SHIP")) {
              cDue = this.quickViewData.data[indx].shipSideExamChargesDue;
              cDueWFee = this.quickViewData.data[indx].shipSideExamChargesDueWithFee;
              cDueWVisaFee = this.quickViewData.data[indx].shipSideExamChargesDueWithVisaFee;
            } else if (this.contGuaranteeDisplay.chargeEvent!=null && this.contGuaranteeDisplay.chargeEvent.toUpperCase().includes("OFF")) {
              cDue = this.quickViewData.data[indx].exportOffSiteExamChargesDue;
              cDueWFee = this.quickViewData.data[indx].exportOffSiteExamChargesDueWithFee;
              cDueWVisaFee = this.quickViewData.data[indx].exportOffSiteExamChargesDueWithVisaFee;
            } else if (tt.isFlatRate == "Y") {
              cDue = tt.totalAmount.replace("$", '');
              xxx = parseFloat(tt.totalFees.replace(/,/g, '')) + parseFloat(cDue.replace(/,/g, ''));
              cDueWFee = xxx.toString();
              xxx = parseFloat(tt.totalVisaFees.replace(/,/g, '')) + parseFloat(cDue.replace(/,/g, ''));
              cDueWVisaFee = xxx.toString();
              this.contGuaranteeDisplay.flatRate = "Y";
            } else if (tt.forRedelivery == "Y") {
              reDelTot = parseFloat(tt.totalAmount.replace(/,/g, '')) + parseFloat(this.quickViewData.data[indx].redeliverExamTotal.replace(/,/g, ''));
              cDue = reDelTot.toString();
              reDelTot = parseFloat(tt.totalAmountWithFee.replace(/,/g, '')) + parseFloat(this.quickViewData.data[indx].redeliverExamTotal.replace(/,/g, ''));
              cDueWFee = reDelTot.toString();
              reDelTotVisa = parseFloat(tt.totalAmountWithVisaFee.replace(/,/g, '')) + parseFloat(this.quickViewData.data[indx].redeliverExamTotal.replace(/,/g, ''));
              cDueWVisaFee = reDelTotVisa.toString();
            } else {
              cDue = tt.totalAmount;
              cDueWFee = tt.totalAmountWithFee;
              cDueWVisaFee = tt.totalAmountWithVisaFee;
            }

            this.workingTotal = parseFloat(this.contGuaranteeDisplay.totalAmount) + parseFloat(cDue.replace(/,/g, ''));
            this.contGuaranteeDisplay.totalAmount = this.workingTotal.toLocaleString("en-US", this.options3);
            this.totalAmount = this.totalAmount + parseFloat(cDue.replace(/,/g, ''));
            this.grandTotal = this.grandTotal + parseFloat(cDue.replace(/,/g, ''));
            if (this.payType == "C") {
              this.workingTotalwFee = parseFloat(this.contGuaranteeDisplay.totalAmountWithFee) + parseFloat(cDueWFee.replace(/,/g, ''));
              this.workingTotalwVisaFee = parseFloat(this.contGuaranteeDisplay.totalAmountWithFeeVisa) + parseFloat(cDueWVisaFee.replace(/,/g, ''));
              this.contGuaranteeDisplay.totalAmountWithFee = this.workingTotalwFee.toLocaleString("en-US", this.options3);
              this.contGuaranteeDisplay.totalAmountWithFeeVisa = this.workingTotalwVisaFee.toLocaleString("en-US", this.options3);
              var xx = parseFloat(cDueWFee.replace(/,/g, '')) - parseFloat(cDue.replace(/,/g, ''));
              var zz = parseFloat(cDueWVisaFee.replace(/,/g, '')) - parseFloat(cDue.replace(/,/g, ''));
              this.totalFees = this.totalFees + xx;
              this.totalFeesVisa = this.totalFeesVisa + zz;
              this.contGuaranteeDisplay.totalFees = this.getNiceCurrency(xx.toString());
              this.contGuaranteeDisplay.totalFeesVisa = this.getNiceCurrency(zz.toString());
              this.grandTotalWFee = this.grandTotalWFee + parseFloat(cDueWFee.replace(/,/g, ''));
              this.grandTotalWVisaFee = this.grandTotalWVisaFee + parseFloat(cDueWVisaFee.replace(/,/g, ''));
            }
            if (tt.forRedelivery == "Y") {
              indx = this.redeliverList.findIndex(xx => xx.container == tt.container);
              if (indx == -1) {
                this.redeliverList.push({"container": tt.container, "amount": this.workingTotal, "amountwFee": this.workingTotalwFee});
              } else {
                this.redeliverList[indx].amount = this.redeliverList[indx].amount + this.workingTotal;
                this.redeliverList[indx].amountwFee = this.redeliverList[indx].amountwFee + this.workingTotalwFee;

              }

            } else {
              this.contGuarArrayDisp.push(this.contGuaranteeDisplay);
            }
          }
        }


        if (!this.deadStopFound) {
          for (var item of this.contGuarArrayDisp) {
            indx = this.redeliverList.findIndex(xx => xx.container == item.container);
            if (indx != -1) {
              item.totalAmount = this.redeliverList[indx].amount.toLocaleString("en-US", this.options3);
              item.totalAmountWithFee = this.redeliverList[indx].amountwFee.toLocaleString("en-US", this.options3);
            }
          }
          if (this.payType == "G") {
            this.myForm.disable();
          } else {
            this.myForm.enable();
          }
          this.subTotalDisp = this.totalAmount.toLocaleString("en-US", this.options3);
          this.totalFeesDisp = this.totalFees.toLocaleString("en-US", this.options3);
          this.totalFeesVisaDisp = this.totalFeesVisa.toLocaleString("en-US", this.options3);
          this.grandTotalDisp = this.grandTotal.toLocaleString("en-US", this.options3);
          this.grandTotalWFeeDisp = this.grandTotalWFee.toLocaleString("en-US", this.options3);
          this.grandTotalWFeeVisaDisp = this.grandTotalWVisaFee.toLocaleString("en-US", this.options3);

          this.submitted = false;
          this.exists = true;
          this.myStepper.selected.completed = true;
          this.myStepper.next();
        }
      });
  }


  selectCCType(){
    this.creditCardEntered = true;
    this.myForm2.controls["ccNum"].setValue(undefined);
  }

  setCCType(){
    this.creditCardEntered = true;
    var xx = this.myForm2.controls["ccNum"].value;
    console.log("xx: "+xx);
    if (xx!=null && xx!=""){
      if (xx.substring(0,1)=="4"){
        this.ccType = "V";
      }else if (xx.substring(0,1)=="3"){
        this.ccType = "A";
      }else if (xx.substring(0,1)=="5" || xx.substring(0,1)=="2"){
        this.ccType = "M";
      }else if (xx.substring(0,1)=="6"){
        this.ccType = "D";
      }
    }else{
      this.ccType = null;
    }


  }

  voidPayments() {
    this.nothingSelected = false;


    this.guaranteeArray = [];
    for (var items of this.selection3.selected) {
      if (items.maherError != null) {
      } else {
        if (items.event_type.toUpperCase().includes("REDELIVERY")) {
          var indx = this.contViewArray.findIndex(xx => xx.unit_gkey == items.unit_gkey);
          if (indx != -1) {
            this.contViewArray[indx].redeliverGuarantees.sort(function(a, b) {
              if (a.event_type < b.event_type) {
                return -1;
              }
              if (a.event_type > b.event_type) {
                return 1;
              }
              return 0;
            })
            for (var xx of this.contViewArray[indx].redeliverGuarantees) {
              if (xx.event_type.toUpperCase().includes("STORAGE") || xx.event_type.toUpperCase().includes("REEFER") || xx.event_type.toUpperCase().includes("REDELIVERY") || xx.event_type.toUpperCase().includes("GATE"))
                this.guaranteeArray.push(xx);
            }
          }
        } else {
          this.guaranteeArray.push(items);
        }
      }
    }
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.guaranteeArray;
    const lhsUserObs$ = this.queryService.paymentVoidProcess(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (datesBack) => {
        this.guaranteeArray = datesBack;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.workingTotal = 0;
        for (var items of this.guaranteeArray) {
          var holdTotal = 0;
          /*
          if (items.event_type.toUpperCase() == 'STORAGE') {
            items.event_type = "Demurrage";
          } else if (items.event_type.toUpperCase() == 'REEFER') {
            items.event_type = 'Power';
          } else if (items.event_type.toUpperCase() == 'SHIPSIDE EXAM') {
            items.event_type = 'Shipside Exam';
          } else if (items.event_type.toUpperCase() == 'COAST GUARD EXAM') {
            items.event_type = 'Coast Guard Exam';
          } else if (items.event_type.toUpperCase() == 'EXPORT EXAM REQUIRED') {
            items.event_type = 'Export Exam Required';
          } else if (items.event_type.toUpperCase() == 'GATE-EXAM') {
            items.event_type = 'Offsite Exam';
          } else if (items.event_type.toUpperCase() == 'GATE-REDELIVERY') {
            items.event_type = 'Export Redelivery Exam';
          } else if (items.event_type.toUpperCase() == 'GATE') {
            items.event_type = 'Export Redelivery Exam';
          }

           */
          if (items.event_type.toUpperCase().includes("REDELIVERY") || items.event_type.toUpperCase() == "GATE") {

            indx = this.guaranteeArray.findIndex(xx => (xx.event_type.toUpperCase() == "DEMURRAGE" || xx.event_type.toUpperCase() == "STORAGE") && xx.id == items.id);
            if (indx != -1) {
              if (items.guarantee_type == "OAC" || this.screenMode == "V") {
                holdTotal = holdTotal + parseFloat(this.guaranteeArray[indx].totalAmount.replace(/,/g, ''));
              } else {
                holdTotal = holdTotal + parseFloat(this.guaranteeArray[indx].totalAmountWithFee.replace(/,/g, ''));
              }
              this.guaranteeArray.splice(indx, 1);
            }

            indx = this.guaranteeArray.findIndex(xx => (xx.event_type.toUpperCase() == "POWER" || xx.event_type.toUpperCase() == "REEFER") && xx.id == items.id);
            if (indx != -1) {
              if (items.guarantee_type == "OAC" || this.screenMode == "V") {
                holdTotal = holdTotal + parseFloat(this.guaranteeArray[indx].totalAmount.replace(/,/g, ''));
              } else {
                holdTotal = holdTotal + parseFloat(this.guaranteeArray[indx].totalAmountWithFee.replace(/,/g, ''));
              }
              this.guaranteeArray.splice(indx, 1);
            }

            if (items.guarantee_type == "OAC" || this.screenMode == "V") {
              holdTotal = holdTotal + parseFloat(items.totalAmount.replace(/,/g, ''));
            } else {
              holdTotal = holdTotal + parseFloat(items.totalAmountWithFee.replace(/,/g, ''));
            }
            this.workingTotal = this.workingTotal + holdTotal;
            items.totalAmount = holdTotal.toString().replace(/,/g, '');
          }


          if (items.guarantee_id != null) {
            items.status = "Successful";
          } else {
            items.status = "Failed";
          }
          if (items.guarantee_start_day != null) {
            items.guarantee_start_day = this.getNiceDate(items.guarantee_start_day);
          }
          if (items.guarantee_end_day != null) {
            items.guarantee_end_day = this.getNiceDate(items.guarantee_end_day);
          }
          items.totalFeesDisp = this.getNiceCurrency(items.totalFees.replace(/,/g, ''));
          if (items.payment_type == "ON_ACCOUNT" || this.screenMode == "V") {
            this.payType = "G";
            items.totalFeesDisp = null;
            items.totalAmountDisp = this.getNiceCurrency(items.totalAmount.replace(/,/g, ''));
            if (items.event_type.toUpperCase().includes("REDELIVERY") || items.event_type.toUpperCase() == "GATE") {
              items.guarantee_amount = items.totalAmountDisp;
            } else {
              if (items.totalAmount.includes("$")) {
                items.totalAmount = items.totalAmount.replace("$", "");
              }
              this.workingTotal = this.workingTotal + parseFloat(items.totalAmount.replace(/,/g, ''));

            }
          } else {
            this.payType = "C";
            items.totalAmountDisp = this.getNiceCurrency(items.totalAmountWithFee.replace(/,/g, ''));
            if (items.event_type.toUpperCase().includes("REDELIVERY") || items.event_type.toUpperCase() == "GATE") {
              items.guarantee_amount = items.totalAmountDisp;
            } else {
              if (items.totalAmountWithFee.includes("$")) {
                items.totalAmountWithFee = items.totalAmountWithFee.replace("$", "");
              }
              this.workingTotal = this.workingTotal + parseFloat(items.totalAmountWithFee.replace(/,/g, ''));
            }
          }
        }
        this.grandTotalDisp = this.getNiceCurrency(this.workingTotal.toString().replace(/,/g, ''));
        this.quickViewData5 = new MatTableDataSource<GuaranteesView>(this.guaranteeArray);
        this.submitted = false;
        this.exists = true;

        if (window.innerWidth <750){
          this.showVoidConfirmationScreen = true;
          this.showPhoneVoidScreen = false;
          window.scrollTo(0, 0);
        }else{
          this.myStepper2.selected.completed = true;
          this.myStepper2.next();
        }
      });
  }


  getMoreCharges(itemIn: ContainerView) {
    this.chargesBackBack = [];
    this.chargesBackBack = itemIn.charges;
    itemIn.charges = itemIn.chargesBack;
    for (var items of itemIn.charges) {
      if (items.type.toUpperCase().includes("STORAGE") || items.type.toUpperCase().includes("REEFER")) {
        this.contGuarantee = {} as ContainerGuarantee;
        this.contGuarantee.apiGkey = itemIn.apiGkey;
        this.contGuarantee.iufv_gkey = itemIn.iufv_gkey;
        this.contGuarantee.extractGkey = items.extractGkey;
        this.contGuarantee.category = itemIn.category;
        this.contGuarantee.container = itemIn.container;
        this.contGuarantee.fromDate = this.getNiceDate(itemIn.received_date);
        if (this.holdDate != null) {
          this.contGuarantee.toDate = this.holdDate;
        } else {
          if (itemIn.end_date_in!=undefined){
            this.contGuarantee.toDate = this.getNiceDate(itemIn.end_date_in);
          }else{
            this.contGuarantee.toDate = this.getNiceDate(itemIn.start_date_in);

          }
        }
        this.contGuarantee.isExam = "N";
        this.contGuarantee.guaranteeType = this.payType;
        this.contGuarantee.line_id = itemIn.line_id;
        this.contGuarantee.forRedelivery = "Y";
        this.contGuarantee.reference = itemIn.reference_number;
        this.contGuarantee.remarks = itemIn.remarks;
        this.contGuarantee.iso_description = itemIn.iso_description;
        this.contGuarantee.received_date_fmt = itemIn.received_date_fmt;
        this.contGuarantee.fte_date_fmt = itemIn.fte_date_fmt;
        this.contGuarantee.in_vessel_description = itemIn.in_vessel_description;
        this.contGuarantee.in_voyage = itemIn.in_voyage;
        this.contGuarantee.typeOfCharge = items.type;

        this.contGuarantee.line_description = itemIn.line_description;
        this.contGuarArray.push(this.contGuarantee);
      }
    }
    itemIn.charges = this.chargesBackBack;

  }

  processComplete() {
    if (window.innerWidth <= 750){
      window.scrollTo(0, 0);
    }

    if (this.oneIsInAlready){
      return;
    }

    this.submitted = true;
    this.oneIsInAlready = true;
    this.noCC = false;
    if ((!this.myForm.valid || !this.myForm2.valid) && this.payType == "C") {
      this.oneIsInAlready = false;
      return;
    }
    if (this.ccType == null && this.payType == "C") {
      this.noCC = true;
      this.oneIsInAlready = false;
      return;
    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;

    if (this.payType == "G") {
      this.myUser.creditCard = {} as CreditCard;
    } else {
      this.myUser.creditCard.expiration_month = this.month;
      this.myUser.creditCard.expiration_year = this.year;
      this.myUser.creditCard.state_region = this.stateRegion;
      this.myUser.creditCard.country = this.country;
      if (this.myUser.creditCard.zip!=null){
        this.myUser.creditCard.zip = this.myUser.creditCard.zip.trim();
      }
      this.myUser.creditCard.account_number = this.myForm2.controls["ccNum"].value;
      this.myUser.creditCard.verification_number = this.myForm2.controls["secCode"].value;
    }

    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.contGuarArray;
    const lhsUserObs$ = this.queryService.paymentProcess(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (datesBack) => {
        this.contGuarArray = datesBack;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      async () => {
        this.guarGuarArrayHist = null;
        this.guarGuarArrayHist = [];
        this.debitCardUsed = false;
        this.submitted = false;
        this.oneIsInAlready = false;
        if (window.innerWidth < 750) {
          this.showSummaryScreen = false;
          this.showConfirmationScreen = true;
          this.showDetailScreen = false;
        }


        for (var hh of this.contGuarArray) {
          if (hh.navisErrors != null) {
            for (var i = 0; i < hh.navisErrors.length; i++) {
              hh.status = hh.status + hh.navisErrors[i];
            }
          } else if (hh.maherError != null) {
            hh.status = hh.maherError;
            break;
          } else {
            hh.status = "Successful";
          }


          hh.chargeEvent = hh.typeOfChargeDescription;
          this.workingTotal = 0;
          var workingTotalMaher: number = 0, workingTotalLine: number = 0;
          var indx = this.contGuarArray.findIndex(xx => xx.typeOfCharge.toUpperCase().includes("REDELIVERY") && xx.container == hh.container);
          if (indx != -1) {
            indx = this.contGuarArray.findIndex(xx => xx.typeOfCharge.toUpperCase() == "STORAGE" && xx.container == hh.container);
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(this.contGuarArray[indx].totalAmountWithFee.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountWithFeeLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountWithFeeMaher.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(this.contGuarArray[indx].totalAmount.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountMaher.replace(/,/g, ''));
              }
              this.contGuarArray.splice(indx, 1);
            }
            indx = this.contGuarArray.findIndex(xx => xx.typeOfCharge.toUpperCase() == "REEFER" && xx.container == hh.container);
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(this.contGuarArray[indx].totalAmountWithFee.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountWithFeeLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountWithFeeMaher.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(this.contGuarArray[indx].totalAmount.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountMaher.replace(/,/g, ''));
              }
              this.contGuarArray.splice(indx, 1);
            }
            var indx = this.contGuarArray.findIndex(xx => xx.typeOfCharge.toUpperCase().includes("REDELIVERY") && xx.container == hh.container);
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(hh.totalAmountWithFee.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountWithFeeLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountWithFeeMaher.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(hh.totalAmount.replace(/,/g, ''));
                workingTotalLine = workingTotalLine + parseFloat(this.contGuarArray[indx].totalAmountLine.replace(/,/g, ''));
                workingTotalMaher = workingTotalMaher + parseFloat(this.contGuarArray[indx].totalAmountMaher.replace(/,/g, ''));
              }
              this.contGuarArray[indx].totalAmount = this.workingTotal.toString().replace(/,/g, '');
              this.contGuarArray[indx].totalAmountLine = workingTotalLine.toString().replace(/,/g, '');
              this.contGuarArray[indx].totalAmountMaher = workingTotalMaher.toString().replace(/,/g, '');
            }
          }

          if (hh.paymentType != null) {
            if (this.payType == "C" && hh.paymentType.toUpperCase() == "DEBIT") {
              this.debitCardUsed = true;
            }


            if (this.payType == "C" && hh.paymentType.toUpperCase() == "CREDIT") {
              hh.totalAmountDisp = this.getNiceCurrency(hh.totalAmount);
              if (this.ccType == "V") {
                hh.grandTotalAmountDisp = this.getNiceCurrency(hh.totalAmountWithVisaFee);
                var xx = parseFloat(hh.totalVisaFees.replace(/,/g, ''));
                hh.totalAmountMaherDisp = this.getNiceCurrency(hh.totalAmountMaher);
              } else {
                hh.grandTotalAmountDisp = this.getNiceCurrency(hh.totalAmountWithFee);
                var xx = parseFloat(hh.totalFees.replace(/,/g, ''));
                hh.totalAmountMaherDisp = this.getNiceCurrency(hh.totalAmountMaher);
              }
              hh.totalFeesDisp = this.getNiceCurrency(xx.toString());
            } else {
              hh.totalAmountDisp = this.getNiceCurrency(hh.totalAmount);
              hh.totalAmountMaherDisp = this.getNiceCurrency(hh.totalAmountMaher);
              hh.totalFeesDisp = "$0.00";
              hh.grandTotalAmountDisp = hh.totalAmountDisp;

            }
            var amountIn;
            if (this.payType == "C" && hh.paymentType.toUpperCase() == "CREDIT") {
              if (this.ccType == "V") {
                amountIn = hh.totalAmountLine;
              } else {
                amountIn = hh.totalAmountLine;
              }
            } else {
              amountIn = hh.totalAmountLine;
            }
            var isDemLine =  this.service.isAStorageSSL(hh.line_id);
            this.foundStorageSSL = this.service.foundStorageSSL;
            if (isDemLine == "L") {
              hh.totalAmountLineDisp = null;
            } else if (isDemLine == "Y") {
              if (hh.typeOfCharge.toUpperCase().includes("STORAGE")) {
                hh.totalAmountLineDisp = this.getNiceCurrency(amountIn);
              }else{
                hh.totalAmountLineDisp = null;
              }
            } else {
              if (hh.typeOfCharge.toUpperCase().includes("STORAGE")){
                hh.totalAmountLineDisp = "Contact Line Op For Demurrage Owed";
              }else{
                hh.totalAmountLineDisp = null;
              }
            }
          }


          if (hh.fromDate != null && hh.fromDate != "") {
            hh.fromDate = hh.fromDate.replace("T", " ");
            if (window.innerWidth >= 750) {
              hh.fromDate = this.getNiceDate(hh.fromDate);
            } else {
              hh.fromDate = hh.fromDate.substr(0, hh.fromDate.indexOf(" "));
            }
          }
          if (hh.toDate != null && hh.toDate != "") {
            hh.toDate = hh.toDate.replace("T", " ");
            if (window.innerWidth >= 750) {
              hh.toDate = this.getNiceDate(hh.toDate);
            } else {
              hh.toDate = hh.toDate.substr(0, hh.toDate.indexOf(" "));
            }
          }

        }
        if (this.payType == "C") {
          this.myUser.creditCard.country = this.countries[this.countries.findIndex(xx => xx.code == this.country)].code;
          this.myUser.creditCard.state_region = this.stateRegions[this.stateRegions.findIndex(xx => xx.code == this.stateRegion)].code;
          this.myUser.creditCard.expiration_month_year = this.month + " / " + this.year;

          if (this.myUser.creditCard.address_2 == null || this.myUser.creditCard.address_2 == "") {
            this.myUser.creditCard.address_2 = " ";
          }
          this.myUser.creditCard.account_number = this.myUser.creditCard.account_number.replace(/.(?=.{4})/g, 'x');
        } else {
          if (this.myUser.address_2 == null) {
            this.myUser.address_2 = " ";
          }
        }
        this.contViewArray.sort(function(a, b) {
          if (a.container < b.container) {
            return -1;
          }
          if (a.container > b.container) {
            return 1;
          }
          return 0;
        })
        for (var ll = 0; ll < this.contViewArray.length; ll++) {
          var inndx1 = this.selection.selected.findIndex(xx => xx.container == this.contViewArray[ll].container);
          var inndx2 = this.selection2.selected.findIndex(xx => xx.container == this.contViewArray[ll].container);
          if (inndx1 == -1 && inndx2 == -1) {
            continue;
          } else {
            if (this.contViewArray[ll].guaranteesArray != null) {
              for (var pp = 0; pp < this.contViewArray[ll].guaranteesArray.length; pp++) {
                this.guarGuarArrayHist.push(this.contViewArray[ll].guaranteesArray[pp]);
              }
            }
          }
        }

        for (var yy of this.guarGuarArrayHist) {
          /*
                    if (yy.event_type.toUpperCase()=='STORAGE'){
                      yy.event_type = "Demurrage";
                    }else if (yy.event_type.toUpperCase()=='REEFER'){
                      yy.event_type = 'Power';
                    }else if (yy.event_type.toUpperCase()=='SHIPSIDE EXAM'){
                      yy.event_type = 'Shipside Exam';
                    }else if (yy.event_type.toUpperCase()=='COAST GUARD EXAM') {
                      yy.event_type = 'Coast Guard Exam';
                    }else if (yy.event_type.toUpperCase()=='GATE-EXAM') {
                      yy.event_type = 'Offsite Exam';
                    }else if (yy.event_type.toUpperCase()=='GATE-REDELIVERY') {
                      yy.event_type = 'Export Redelivery Exam';
                    } else if (yy.event_type.toUpperCase() == 'GATE') {
                      yy.event_type = 'Export Redelivery Exam';
                    }

           */

          if (yy.guarantee_type == "STPAID") {
            continue;
          }

          if (yy.voided_or_expired_date != null) {
            yy.voided_or_expired_date_disp = "Yes";
          } else {
            yy.voided_or_expired_date_disp = "No";
          }
          if (yy.guarantee_start_day != null) {
            yy.guarantee_start_day = this.getNiceDate(yy.guarantee_start_day);
          }
          if (yy.guarantee_end_day != null) {
            yy.guarantee_end_day = this.getNiceDate(yy.guarantee_end_day);
          }
          if (yy.created != null) {
            yy.created = this.getNiceDate(yy.created);
          }
          if (yy.creator.indexOf("/") > 0) {
            yy.creator = yy.creator.substring(0, yy.creator.indexOf("/"));
          }
        }
        this.futureDay = this.today;
        this.futureDay.setDate(this.today.getDate() + 6);
        this.futureDayDisp = this.getNiceDateTimeForDate3(this.futureDay);

        this.quickViewData6 = new MatTableDataSource<ContainerGuarantee>(this.contGuarArray);
        this.quickViewData3 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayHist);
        this.processed = true;
        this.exists = true;
        this.myStepper.selected.completed = true;
        this.myStepper.next();
      });


  }





  returnToSelection() {
    //this.setupScreen();
    this.exists = false;
    this.allDone = false;
    if (window.innerWidth < 750){
      this.showSummaryScreen = false;
      this.showDetailScreen = true;
    }else{
      this.myStepper.selected.completed = false;
      this.myStepper.previous();
    }


  }


  changeCountry() {
    this.stateRegions = [];
    if (this.country.toUpperCase() == "US") {
      this.stateRegions = this.states;
    } else {
      this.stateRegions = this.regions;
    }
    this.stateRegion = this.stateRegions[0].code;
  }

  showContainersFromList() {
    var indx = this.listData.findIndex(xx => xx.id == this.savedList);
    if (indx != -1) {
      this.txtFromArea = "";
      for (var ii = 0; ii < this.listData[indx].data.length; ii++) {
        this.txtFromArea = this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }


  getNiceDate(dateIn: string): string {
    this.date1 = new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options4);
  }

  getNiceDate3(dateIn: string): Date {
    this.date1 = new Date(dateIn);
    return this.date1;
  }

  getNiceDateTimeForDate2(dateIn: Date): string {
    if (dateIn!=undefined && dateIn!=null){
      return dateIn.toLocaleDateString("en-US", this.options);
    }
  }

  getNiceDateTimeForDate3(dateIn: Date): string {
    return dateIn.toLocaleDateString("en-US", this.optionsFuture);
  }

  getNiceCurrency(numberIn: string): string {
    if (numberIn.includes("$")) {
      numberIn = numberIn.replace("$", "");
    }
    if (numberIn.includes(",")) {
      numberIn = numberIn.replace(",", "");
    }
    this.number1 = parseFloat(numberIn);
    return this.number1.toLocaleString("en-US", this.options3);
  }


  updateContainerList(fromWhere: string) {
    this.insertNoConts = false;
    this.submitted = true;
    this.insertListExists = false;
    this.noListName = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj = {} as ListData;
    if (fromWhere == "D") {
      var indx = this.listData.findIndex(xx => xx.id == this.savedList);
      if (indx != -1) {
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    } else {
      if (this.txtFromArea == undefined || this.txtFromArea == "") {
        if (fromWhere == "I" || fromWhere == "U") {
          this.insertNoConts = true;
        }
        return;
      }
      if (fromWhere == "I" && (this.myNewListName == null || this.myNewListName == "")) {
        this.noListName = true;
        return;
      }


      if ((fromWhere=="U" ) && (this.savedList==null || this.savedList=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere == "I" && this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type == "E") != -1) {
        this.insertListExists = true;
        return;
      }
      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length == 0) {
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere != "D") {
        if (fromWhere == "I") {
          this.listDataObj.type = "E";
          this.listDataObj.name = this.myNewListName;
        } else {
          var indx = this.listData.findIndex(xx => xx.id == this.savedList);
          if (indx != -1) {
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList;
        this.fillUpSavedLists();
        if (this.savedLists.length > 0) {
          if (fromWhere == "I") {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx => xx.code == this.myNewListName)].id;
          } else if (fromWhere == "D") {
            this.savedList = this.savedLists[0].id;
          } else {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx => xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere == "I") {
          this.myApp.showSuccessBanner("", "the new list has been created successfully", "importCharges");
        } else if (fromWhere == "D") {
          this.myApp.showSuccessBanner("", this.myNewListName + " has been deleted successfully", "importCharges");
        } else {
          this.myApp.showSuccessBanner("", "List has been updated successfully", "importCharges");

        }

        this.submitted = false;


      });

  }

  deleteHit() {
    this.deleteVoidSwitch = "L";
    this.myApp.showConfirmBanner("Confirm", "confirm delete of list: " + this.savedLists[this.savedLists.findIndex(xx => xx.id == this.savedList)].description, "importCharges");
  }

  getListData() {

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listDataObj.type = "E";
    this.listData.push(this.listDataObj);
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.listData;
    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.fillUpSavedLists();
      });
  }

  setCheckedField() {
    this.exists = false;
    this.allDone = false;
    this.processed = false;
    this.showQuickView = false;
    this.showQuickView2 = false;
    this.showDetailScreen = false;
    this.showQuickViewVoid = false;
    this.showConfirmationScreen = false;
    this.showPhoneVoidScreen = false;
    this.showSummaryScreen = false;
    this.showPhoneDetailScreen = false;
    this.showVoidConfirmationScreen = false;
    this.showInquiryScreen = false;
  }

  public wipeOutSearch() {
    this.txtFromArea = null;
    this.showQuickView = false;
  }

  hideIt(rowIn: ContainerView): boolean {
    if (rowIn.charges.length <= 1) {
      return true;
    } else {
      return false;
    }
  }

  setAndReset(varIn: string){
    this.payType = varIn;
    this.resetScreen();
  }

  resetScreen() {

    this.setCheckedField();
    this.takenDates = [];

    this.last_reference_number = null;
    this.selection.clear()
    this.selection2.clear();
    this.selection3.clear();
    this.allChecked = false;
    this.allDatesChecked = false;
    this.allRefsChecked = false;
    this.allRemarksChecked = false;
    this.creditCardEntered = false;
    this.myForm.reset(true);
    this.myForm2.reset(true);
    this.showQuickView = false;
    this.badContainer = false;
    this.foundStorageSSL = false;
    this.service.foundStorageSSL = false;
    this.checkCheckedMaher = false;
    this.checkCheckedLine = false;
    this.noPayType = false;
    this.didntEnterShit = false;
    this.allDone = false;
    this.badChars = false;
    this.showQuickView = false;
    this.showConfirmationScreen = false;
    this.showCCMessage = false;
    this.showSummaryScreen = false;
    this.showPhoneVoidScreen = false;
    this.showPhoneDetailScreen = false;
    this.showVoidConfirmationScreen = false;
    this.showInquiryScreen = false;
    this.exists = false;
    this.processed = false;
    this.myUser.creditCard = {} as CreditCard;
    if (this.myStepper != null) {
      this.myStepper.selected.completed = false;
    }
    if (this.myStepper2 != null) {
      this.myStepper2.selected.completed = false;
    }


  }

  getSearchItems() {

    if (this.oneIsInAlready){
      return;
    }

    this.resetScreen();
    this.submitted = true;
    this.oneIsInAlready = true;
    if (this.txtFromArea == undefined || this.txtFromArea==" ") {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

    this.txtArray2 = [];

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');

    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

      if (this.payType == null && this.screenMode == "E" && (this.myUser.role == "LINEOP" || this.myUser.credit_status == 'OAC')) {
        this.noPayType = true;
        this.oneIsInAlready = false;
        return;
      }


    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }
      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }
    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

    this.contViewArray = [];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.myUser.callingCalculator = "N";
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    for (var items of this.txtArray2) {
      this.contView = {} as ContainerView;
      if (this.screenMode == "E" && (this.myUser.role == "LINEOP" || this.myUser.credit_status == "OAC")) {
        this.contView.guaranteeType = this.payType;
      } else {
        this.contView.guaranteeType = "C";
        this.payType = "C";
      }
      this.contView.container = items.valueOf();
      if (this.contViewArray.findIndex(xx => xx.container == items.valueOf()) == -1) {
        this.contViewArray.push(this.contView);
      }
    }
    this.clientRequest.requestData = this.contViewArray;


    var lhsUserObs$;
    if (this.screenMode == "E") {
      lhsUserObs$ = this.queryService.paymentGetContainers(this.clientRequest);
    } else if (this.screenMode == "I") {
      lhsUserObs$ = this.queryService.paymentInquiryGetContainers(this.clientRequest);
    } else {
      lhsUserObs$ = this.queryService.paymentVoidGetContainers(this.clientRequest);
    }

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.contViewArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.showQuickView2 = false;
        this.showQuickView = false;
        this.showDetailScreen = false;
        this.showQuickViewVoid = false;
        this.foundStorageSSL = false;
        this.showMaherStatement = false;

        if (this.screenMode == "E"){
          if (this.myUser.role!="LINEOP"){
            this.bothChecked = false;
          }else{
            this.bothChecked = true;
          }
        }

        if (this.screenMode == "E" || (this.screenMode == "I" && this.contViewArray.length > 1)) {
          if (this.screenMode == "I") {
            this.showQuickView2 = true;
          } else {
            this.showQuickView = true;
          }
          this.setupScreen();
          if (window.innerWidth > 750 && window.innerWidth <1150){
            this.ipadAppear = false;
          }
          if (window.innerWidth < 750){
            this.contView = this.contViewArray[0];
            this.showPhoneDetailScreen = true;
          }
            this.quickViewData = new MatTableDataSource<ContainerView>(this.contViewArray);
            this.fillTakenDates();
        } else if (this.screenMode == "I") {
          this.contView = null;
          this.contView = {} as ContainerView;
          this.contView = this.contViewArray[0];

          if (this.contView.maherError != null) {
            this.theError = this.contView.maherError;
            this.badContainer = true;
            return;
          }
          if (window.innerWidth > 750 && window.innerWidth <1150){
            this.ipadAppear = false;
          }
          this.quickViewData = new MatTableDataSource<ContainerView>(this.contViewArray);
          this.showDetailScreen = true;
          this.showInquiryScreen = true;
          this.guarGuarArrayHist = [];
          this.guarGuarArrayOtherHist = [];

          this.setupScreen();
          this.formatDetailScreen();

          if (this.myUser.role == "SHIPPER") {
            this.guarGuarArrayHist = this.contViewArray[0].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code && xx.n4_user_id == this.myUser.username);
            this.guarGuarArrayOtherHist = this.contViewArray[0].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code || (xx.guarantor == this.myUser.company_code && xx.n4_user_id != this.myUser.username));
          } else {
            this.guarGuarArrayHist = this.contViewArray[0].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code);
            this.guarGuarArrayOtherHist = this.contViewArray[0].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code);
          }

          this.quickViewData3 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayHist);
          this.quickViewData4 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayOtherHist);
        } else {
          if (window.innerWidth < 750){
            this.contView = this.contViewArray[0];
            this.showPhoneVoidScreen = true;
          }else{
            this.showQuickViewVoid = true;
          }
          this.setupScreen();
          this.guaranteeArray = [];
          for (var items of this.contViewArray) {
            if (items.maherError != null) {
              this.guaranteesView = {} as GuaranteesView;
              this.guaranteesView.id = items.container;
              this.guaranteesView.vesselVoyageDisp = items.maherError;
              this.guaranteesView.maherError = items.maherError;
              this.guaranteeArray.push(this.guaranteesView);
            } else {
              for (var guars of items.guaranteesArray) {
                guars.category_description = items.category_description;
                this.guaranteeArray.push(guars);
              }
            }
          }
          if (window.innerWidth > 750 && window.innerWidth <1150){
            this.ipadAppear = false;
          }

          this.quickViewData4 = new MatTableDataSource<GuaranteesView>(this.guaranteeArray);

        }
        this.submitted = false;
        this.oneIsInAlready = false;

      });

    //  }
  }

  setupScreen() {
    for (var item of this.contViewArray) {
      if (item.maherError != null) {
        if (item.maherError.includes("please contact OOCL")){
          var indxOfLink = item.maherError.indexOf("link");
          var newString = item.maherError.substring(0,indxOfLink) + "<a href='https://www.oocl.com/usa/eng/localinformation/localnews/2022/Pages/2022Feb24.aspx' target=\"_blank\">" ;
          newString = newString + "&nbsp;" + item.maherError.substring(indxOfLink, indxOfLink+4) + "</a>" + "&nbsp;";
          newString = newString + item.maherError.substring(indxOfLink+5);
          item.vesselVoyage =  newString;
        }else{
          item.vesselVoyage = item.maherError;
        }
        item.totalAmount = null;
        item.totalAmountLine = null;
        item.totalAmountMaher = null;
      } else if (item.navisErrors != null) {
        item.vesselVoyage = item.navisErrors[0];
        item.totalAmount = null;
        item.totalAmountLine = null;
        item.totalAmountMaher = null;
      } else if ((item.charges.length == 0 && this.screenMode == "E") || item.freight_kind == "MTY") {
        item.vesselVoyage = "No Charges Due on This Container";
        item.maherError = item.vesselVoyage;
        item.fte_datefmt = null;
        item.fte_date_fmt = null;
        item.fte_power_datefmt = null;
        item.power_fte_date_fmt = null;
        item.booking = null;
        item.totalAmount = null;
        item.totalAmountLine = null;
        item.totalAmountMaher = null;
      } else {
        if (item.category_description.toUpperCase() == 'IMPORT') {
          item.vesselVoyage = item.in_vessel_description + " / " + item.in_voyage;
        } else {
          if (item.out_vessel_description != null) {
            item.vesselVoyage = item.out_vessel_description + " / " + item.out_voyage;
          }
        }
        item.rangeMode = true;
        item.remarks = null;




        item.start_datefmt = new Date();
        if ((item.fte_date != null && item.fte_date != "" && item.category!="EXPRT")) {
          item.fte_datefmt = this.getNiceDate3(item.fte_date);
          item.fte_datefmt.setDate(item.fte_datefmt.getDate() + 1);
          item.fte_date_fmt2 = this.getNiceDate(item.fte_date);
          item.fte_date_fmt3 = this.getNiceDate(item.fte_date);
          item.start_datefmt = item.fte_datefmt;
        }
        if (item.power_fte_date != null && item.power_fte_date != "" && item.category!="EXPRT") {
          item.fte_power_datefmt = this.getNiceDate3(item.power_fte_date);
          item.fte_power_datefmt.setDate(item.fte_power_datefmt.getDate() + 1);
          item.power_fte_date_fmt = this.getNiceDate(item.power_fte_date);
          item.start_datefmt = item.fte_power_datefmt;
        }

        if (item.storage_paid_through_date!=null && item.fte_date!=null){
          this.guaranteesView = {} as GuaranteesView;
          this.guaranteesView.id = item.container;
          this.guaranteesView.guarantee_start_day = item.fte_date;
          this.guaranteesView.guarantee_end_day = item.storage_paid_through_date;
          this.guaranteesView.event_type = "STPAID";
          this.guaranteesView.guarantee_type = "STPAID";
          this.guaranteesView.guarantee_amount = "0";
          item.guaranteesArray.push(this.guaranteesView);
        }

        this.showCCMessage = false;
        if (this.payType == "C") {
          if (item.totalFees!=null && (Number.parseFloat(item.totalAmountWithAmexFee)>0.00 || Number.parseFloat(item.totalAmountWithDiscFee)>0.00 || Number.parseFloat(item.totalAmountWithMasterCardFee)>0.00) || Number.parseFloat(item.totalAmountWithVisaFee)>0.00){
            this.showCCMessage = true;
          }
          if (item.endDateForCreditCards != null) {
            item.end_datefmt = this.getNiceDate3(item.endDateForCreditCards);
          }
        } else {
          if (item.endDateForGuarantees != null) {
            item.end_datefmt = this.getNiceDate3(item.endDateForGuarantees);
          }
        }


        if (item.guaranteesArray != null && item.guaranteesArray.length > 0) {
          for (var gua of item.guaranteesArray) {
            if (gua.guarantee_start_day != null) {
              if (window.innerWidth >= 750){
                gua.guarantee_start_day = this.getNiceDate(gua.guarantee_start_day);
              }else{
                gua.guarantee_start_day =gua.guarantee_start_day.substr(0,gua.guarantee_start_day.indexOf(" "));
                gua.guarantee_start_day = moment(gua.guarantee_start_day).format("MM/DD/YYYY");
              }
            }
            if (gua.guarantee_end_day != null) {
              if (window.innerWidth >= 750){
                gua.guarantee_end_day = this.getNiceDate(gua.guarantee_end_day);
              }else{
                gua.guarantee_end_day =gua.guarantee_end_day.substr(0,gua.guarantee_end_day.indexOf(" "));
                gua.guarantee_end_day = moment(gua.guarantee_end_day).format("MM/DD/YYYY");
              }
            }
            gua.guarantee_amount = this.getNiceCurrency(gua.guarantee_amount);
            if (gua.voided_or_expired_date != null) {
              gua.voided_or_expired_date_disp = "Voided";
            } else if ((gua.guarantee_type == "CREDIT_PREAUTHORIZE" && gua.payment_type.toUpperCase() == "CREDIT") || (gua.payment_type=='DEBIT')) {
              gua.voided_or_expired_date_disp = "Authorized";
            } else {
              gua.voided_or_expired_date_disp = "Guaranteed";
            }
            gua.vesselVoyageDisp = item.vesselVoyage;
            gua.sslDisp = item.ssl_owner_code;
            this.workingTotal = 0;


            if (this.screenMode == "I" && gua.event_type.toUpperCase() == "GATE") {
              var indx = item.guaranteesArray.findIndex(xx => xx.event_type.toUpperCase() == "GATE");
              if (indx != -1) {
                if ((indx + 1) <= (item.guaranteesArray.length - 1)) {


                  if (item.guaranteesArray[indx + 1].event_type.toUpperCase() == "STORAGE") {
                    if (gua.guarantee_type != "OAC") {
                      this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx + 1].totalAmountWithFee.replace(/,/g, ''));
                    } else {
                      this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx + 1].totalAmount.replace(/,/g, ''));
                    }
                  }
                  if (item.guaranteesArray[indx + 1].event_type.toUpperCase() == "POWER") {
                    if (gua.guarantee_type != "OAC") {
                      this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx + 1].totalAmountWithFee.replace(/,/g, ''));
                    } else {
                      this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx + 1].totalAmount.replace(/,/g, ''));
                    }
                  }
                }

                this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmount.replace(/,/g, ''));
                item.guaranteesArray[indx].totalAmount = this.getNiceCurrency(this.workingTotal.toString().replace(/,/g, ''));
                item.guaranteesArray[indx].guarantee_amount = item.guaranteesArray[indx].totalAmount;
                item.guaranteesArray[indx].event_type = 'Export Redelivery Exam';
                if (item.guaranteesArray[indx].guarantee_start_day != null) {
                  item.guaranteesArray[indx].guarantee_start_day = this.getNiceDate(item.guaranteesArray[indx].guarantee_start_day);
                }
                if (item.guaranteesArray[indx].guarantee_end_day != null) {
                  item.guaranteesArray[indx].guarantee_end_day = this.getNiceDate(item.guaranteesArray[indx].guarantee_end_day);
                }


                item.guaranteesArray[indx].vesselVoyageDisp = item.vesselVoyage;
                item.guaranteesArray[indx].sslDisp = item.ssl_owner_code;
                item.guaranteesArray.splice(indx + 1, 1);


              }
            } else {
              /*
                if (gua.event_type.toUpperCase() == 'STORAGE') {
                  gua.event_type = "Demurrage";
                } else if (gua.event_type.toUpperCase() == 'REEFER') {
                  gua.event_type = 'Power';
                } else if (gua.event_type.toUpperCase() == 'SHIPSIDE EXAM') {
                  gua.event_type = 'Shipside Exam';
                } else if (gua.event_type.toUpperCase() == 'COAST GUARD EXAM') {
                  gua.event_type = 'Coast Guard Exam';
                } else if (gua.event_type.toUpperCase() == 'EXPORT EXAM REQUIRED') {
                  gua.event_type = 'Export Exam Required';
                } else if (gua.event_type.toUpperCase() == 'GATE-EXAM') {
                  gua.event_type = 'Offsite Exam';
                } else if (gua.event_type.toUpperCase() == 'GATE-REDELIVERY') {
                  gua.event_type = 'Export Redelivery Exam';
                } else if (gua.event_type.toUpperCase() == 'GATE') {
                  gua.event_type = 'Export Redelivery Exam';
                }

               */
              //      var indx = item.guaranteesArray.findIndex(xx => xx.event_type.toUpperCase().includes("REDELIVERY") || xx.event_type.toUpperCase()=="GATE");
              //      if (indx!=-1) {

              if ((gua.category=="EXPRT"  || gua.category=="TRSHP") && gua.event_type=="STORAGE" && this.screenMode=="V"){
                gua.vesselVoyageDisp = "Container has been Rerouted";
                item.vesselVoyage = "Container has been Rerouted";
                item.maherError = item.vesselVoyage;
                item.fte_datefmt = null;
                item.fte_date_fmt = null;
                item.fte_power_datefmt = null;
                item.power_fte_date_fmt = null;
                item.booking = null;
                item.totalAmount = null;
              }


              if (gua.event_type.toUpperCase().includes("REDELIVERY") || gua.event_type.toUpperCase() == "GATE") {
                item.redeliverGuarantees = Object.assign([], JSON.parse(JSON.stringify(item.guaranteesArray)));
                indx = item.guaranteesArray.findIndex(xx => xx.event_type.toUpperCase() == "DEMURRAGE" || xx.event_type.toUpperCase() == "STORAGE");
                if (indx != -1) {
                  if (gua.guarantee_type == "OAC" || this.screenMode == "V") {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmount.replace(/,/g, ''));
                  } else {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmountWithFee.replace(/,/g, ''));
                  }
                  item.guaranteesArray.splice(indx, 1);
                }
                indx = item.guaranteesArray.findIndex(xx => xx.event_type.toUpperCase() == "POWER");
                if (indx != -1) {
                  if (gua.guarantee_type == "OAC" || this.screenMode == "V") {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmount.replace(/,/g, ''));
                  } else {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmountWithFee.replace(/,/g, ''));
                  }
                  item.guaranteesArray.splice(indx, 1);
                }
                var indx = item.guaranteesArray.findIndex(xx => xx.event_type.toUpperCase().includes("REDELIVERY") || xx.event_type.toUpperCase() == "GATE");
                if (indx != -1) {
                  if (gua.guarantee_type == "OAC" || this.screenMode == "V") {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmount.replace(/,/g, ''));
                  } else {
                    this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmountWithFee.replace(/,/g, ''));
                  }
                  //     this.workingTotal = this.workingTotal + parseFloat(item.guaranteesArray[indx].totalAmount.replace(/,/g, ''));

                  item.guaranteesArray[indx].totalAmount = this.getNiceCurrency(this.workingTotal.toString().replace(/,/g, ''));
                  item.guaranteesArray[indx].guarantee_amount = item.guaranteesArray[indx].totalAmount;

                  item.guaranteesArray[indx].event_type = 'Export Redelivery Exam';
                  if (item.guaranteesArray[indx].guarantee_start_day != null) {
                    item.guaranteesArray[indx].guarantee_start_day = this.getNiceDate(item.guaranteesArray[indx].guarantee_start_day);
                  }
                  if (item.guaranteesArray[indx].guarantee_end_day != null) {
                    item.guaranteesArray[indx].guarantee_end_day = this.getNiceDate(item.guaranteesArray[indx].guarantee_end_day);
                  }
                  item.guaranteesArray[indx].vesselVoyageDisp = item.vesselVoyage;
                  item.guaranteesArray[indx].sslDisp = item.ssl_owner_code;

                }
              } else {
                if (gua.guarantee_type == "CREDIT_PREAUTHORIZE" && gua.payment_type.toUpperCase() == "CREDIT") {
                  if (gua.card_type=="VISA"){
                    gua.totalVisaFees = this.getNiceCurrency(gua.totalVisaFees.replace(/,/g, ''));
                    gua.totalAmountWithVisaFee = this.getNiceCurrency(gua.totalAmountWithVisaFee.replace(/,/g, ''));
                  }else{
                    gua.totalFees = this.getNiceCurrency(gua.totalFees.replace(/,/g, ''));
                    gua.totalAmountWithFee = this.getNiceCurrency(gua.totalAmountWithFee.replace(/,/g, ''));
                  }
                } else {
                  gua.totalFees = null;
                  gua.totalVisaFees = null;
                  gua.totalAmountWithFee = gua.guarantee_amount;
                }
              }
            }
          }
        }

        if (this.screenMode == "E") {
          this.workingTotal = 0;
          var indx = item.charges.findIndex(xx => xx.type.toUpperCase().includes("REDELIVERY") || xx.type.toUpperCase() == "GATE");
          if (indx != -1) {

            var indx = item.charges.findIndex(xx => xx.type.toUpperCase().includes("REDELIVERY") || xx.type.toUpperCase() == "GATE");
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
            }

            indx = item.charges.findIndex(xx => xx.type.toUpperCase() == "MOUNTING");
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
              item.charges.splice(indx, 1);
            }
            indx = item.charges.findIndex(xx => xx.type.toUpperCase() == "GROUNDING");
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
              item.charges.splice(indx, 1);
            }

            item.redeliverExamTotal = this.workingTotal.toString();

            item.chargesBack = Object.assign([], item.charges)
            indx = item.charges.findIndex(xx => xx.type.toUpperCase() == "STORAGE");
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
              item.charges.splice(indx, 1);
            }
            indx = item.charges.findIndex(xx => xx.type.toUpperCase() == "REEFER");
            if (indx != -1) {
              if (this.payType == "C") {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
              item.charges.splice(indx, 1);
            }
            var indx = item.charges.findIndex(xx => xx.type.toUpperCase().includes("REDELIVERY") || xx.type.toUpperCase() == "GATE");
            if (indx != -1) {
              if (this.payType == "C") {
                //          this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].totalAmountWithFee.replace(/,/g, ''));
              } else {
                //           this.workingTotal = this.workingTotal + parseFloat(item.charges[indx].amout.replace(/,/g, ''));
              }
              item.charges[indx].amout = this.getNiceCurrency(this.workingTotal.toString().replace(/,/g, ''));
            }


          }
        }
        if (parseFloat(item.exportRedeliveryChargesDue) > 0) {
          item.demurrageBalanceDue = "$0.00";
          item.demurrageBalanceDueMaher = "$0.00";
          item.demurrageBalanceDueLine = null;
          item.totalAmountLine = null;
        } else {
          item.demurrageBalanceDue = this.getNiceCurrency(item.demurrageBalanceDue);
          item.demurrageBalanceDueMaher = this.getNiceCurrency(item.demurrageBalanceDueMaher);

          if (item.category!="EXPRT"){
            this.showMaherStatement = true;
            var isDemLine = this.service.isAStorageSSL(item.line_id);
            this.foundStorageSSL = this.service.foundStorageSSL;
            if (isDemLine=="L"){
              item.demurrageBalanceDueLine = null;
              item.totalAmountLine = null;
            }else if (isDemLine=="Y"){
              item.demurrageBalanceDueLine = this.getNiceCurrency(item.demurrageBalanceDueLine);
              item.totalAmountLine = this.getNiceCurrency(item.demurrageBalanceDueLine);
            }else{
              item.demurrageBalanceDueLine = "Contact Line Op For Demurrage Owed";
              item.totalAmountLine = "Contact Line Op For Demurrage Owed";
            }
          }else{
            item.demurrageBalanceDueLine = null;
            item.totalAmountLine = null;
          }


        }
        item.powerBalanceDue = this.getNiceCurrency(item.powerBalanceDue);
        var tot = parseFloat(item.coastGuardExamChargesDue) + parseFloat(item.exportOffSiteExamChargesDue) + parseFloat(item.exportRedeliveryChargesDue) + parseFloat(item.shipSideExamChargesDue);
        item.examTotal = tot.toString();
        item.examTotal = this.getNiceCurrency(item.examTotal);




        if (item.charges != null && item.charges.length > 0) {

          if (item.charges.length > 1) {
            item.fte_date_fmt2 = null;
          }
          for (var chg of item.charges) {
            chg.rangeMode = true;



            if (chg.type.toUpperCase() == 'STORAGE') {
              //chg.type = "Demurrage";

              chg.full_date = " ";

              if (item.fte_date != null) {
                chg.fte_datefmt = this.getNiceDate3(item.fte_date);
                chg.fte_datefmt.setDate(chg.fte_datefmt.getDate() + 1);
                if (window.innerWidth >= 750){
                  chg.fte_date_fmt = this.getNiceDate(item.fte_date);
                }else{
                  chg.fte_date_fmt = item.fte_date;
                }
                chg.start_datefmt = item.fte_datefmt;
              }
            } else if (chg.type.toUpperCase() == 'REEFER') {
              // chg.type = 'Power';
              if (item.power_fte_date != null) {
                chg.fte_datefmt = this.getNiceDate3(item.power_fte_date);
                chg.fte_datefmt.setDate(chg.fte_datefmt.getDate() + 1);
                if (window.innerWidth >= 750){
                  chg.fte_date_fmt = this.getNiceDate(item.power_fte_date);
                }else{
                  chg.fte_date_fmt = item.power_fte_date;
                }
                chg.start_datefmt = chg.fte_datefmt;
              }
            } else if (chg.type.toUpperCase() == 'GATE-REDELIVERY') {
              // chg.type = 'Export Redelivery Exam';
              chg.start_datefmt = new Date();
              chg.rangeMode = false;
              item.rangeMode = false;
            } else if (chg.type.toUpperCase() == 'MOUNTING' || chg.type.toUpperCase() == 'GROUNDING') {
              chg = null;
              continue;
            }

            chg.container = item.container;
            chg.iufv_gkey = item.iufv_gkey;
            chg.apiGkey = item.apiGkey;
            chg.line_id = item.line_id;
            if (item.charges.length == 1) {
              item.chargeDisplay = item.charges[0].typeDescription;
              if (item.chargeDisplay.toUpperCase().includes("REDELIVERY")) {
                item.fte_datefmt = null;
                item.fte_date_fmt2 = null;
                item.start_datefmt = new Date();
              }
            } else {
              if (chg.type=="STORAGE"){
                var cMah, cLine;
                this.showMaherStatement = true;
                chg.amoutMaher = this.getNiceCurrency(chg.amout);
                cMah = chg.amoutMaher.replace("$", '');
                cMah = cMah.replace(/,/g, '');
                if (item.totalAmountLine!=null && !item.totalAmountLine.includes("Contact Line")){
                  chg.amoutLine = this.getNiceCurrency(item.totalAmountLine);
                  cLine = chg.amoutLine.replace("$", '');
                  cLine = cLine.replace(/,/g, '');
                  chg.amout = (Number.parseFloat(cMah) + Number.parseFloat(cLine)).toString();
                }else{
                  chg.amout = (Number.parseFloat(cMah)).toString();
                }

                chg.amout = this.getNiceCurrency(chg.amout);
                chg.amoutMaher = this.getNiceCurrency(cMah);

                var isDemLine = this.service.isAStorageSSL(item.line_id);
                this.foundStorageSSL = this.service.foundStorageSSL;
                if (isDemLine=="L"){
                  chg.amoutLine  = null;
                }else if (isDemLine=="Y"){
                  chg.amoutLine = this.getNiceCurrency(cLine);
                }else{
                  chg.amoutLine  = "Contact Line Op For Demurrage Owed";
                }


                item.totalAmountMaher = null;
                item.totalAmountLine = null;
              }

              item.chargeDisplay = null;
            }
            if (item.navisErrors != null || item.maherError != null) {
              chg.amout = null;
            } else {
              var indx = item.charges.findIndex(xx => xx.type.toUpperCase().includes("REDELIVERY"));
              if (indx == -1) {
                if ((item.chargesLine==null || item.chargesLine.length==0) || (chg.type!="STORAGE") ){
                  chg.amout = this.getNiceCurrency(chg.amout);

                }
              }
            }

          }
        } else {
          item.fte_datefmt = null;
          item.fte_power_datefmt = null;
          item.booking = null;
        }
      }
    }
  }

  setLastRemark(rowIn: ContainerView){
    this.last_remark = rowIn.remarks;
  }

  clearAllRemarks(){
    this.quickViewData.data.forEach(row => {
      this.allRemarksChecked = false;
      if (row.charges.length>1){
        for (var xxx=0; xxx<row.charges.length; xxx++){
          row.charges[xxx].remarks = null;
          this.last_remark = null;
        }
      }else{
        row.remarks = null;
        this.remarks = null;
      }
    })
  }

  setAllRemarks() {
      this.quickViewData.data.forEach(row => {
        if (this.last_remark!=null){
          this.allRemarksChecked = true;
          if (row.charges.length>1){
            for (var xxx=0; xxx<row.charges.length; xxx++){
              row.charges[xxx].remarks = this.last_remark;
            }
          }else{
            row.remarks = this.last_remark;
          }
        }
      })
  }


  fillTakenDates(){
    this.takenDates = [];
    this.quickViewData.data.forEach(row => {
      row.guaranteesArray.forEach(gRow => {
        let workDate = this.getNiceDate(gRow.guarantee_start_day);
        if (gRow.voided_or_expired_date==null){
          if (this.takenDates.findIndex(xx => xx.date == workDate && xx.container == gRow.id && xx.event == gRow.event_type) == -1) {
            this.takenDates.push({"date": workDate, "container": gRow.id, "event": gRow.event_type});
          }

          let endDate = this.getNiceDate(gRow.guarantee_end_day);
          if (workDate!=endDate){
            var stillGoing = true;
            while (stillGoing) {
              this.workDate = this.getNiceDate3(workDate);
              this.workDate.setDate(this.workDate.getDate() + 1); //adding 1 to the toDate
              workDate = this.getNiceDateTimeForDate2(this.workDate);

              if (workDate==endDate) {
                stillGoing = false;
              }
              if (this.takenDates.findIndex(xx => xx.date == workDate && xx.container == gRow.id && xx.event == gRow.event_type) == -1) {
                this.takenDates.push({"date": workDate, "container": gRow.id, "event": gRow.event_type});
              }
            }
          }
        }
      })
    })
  }


  checkIfDateIsGoodForDuplicate(rowIn: ContainerView, typeIn: string) :boolean {
    var lastStart = this.getNiceDate3(this.last_begin_date);
    var lastEnd = this.getNiceDate3(this.last_end_date);
    var rowStart = this.getNiceDateTimeForDate2(rowIn.start_datefmt);
    var rowEnd = this.getNiceDateTimeForDate2(rowIn.end_datefmt);
    var rowStart2 = this.getNiceDate3(rowStart);
    var rowEnd2 = this.getNiceDate3(rowEnd);

      if (lastStart.getTime() >= rowStart2.getTime() && lastEnd.getTime() <= rowEnd2.getTime()) { //check if dates chosen are between begin and end dates of each record
        var beginDate = null, endDate = null;
        beginDate = this.getNiceDate3(this.last_begin_date);
        endDate = this.getNiceDate3(this.last_end_date);

        this.workGuaranteesArray = [];
        this.workGuaranteesArray = rowIn.guaranteesArray.filter(xx => xx.event_type == typeIn && xx.id == rowIn.container);

        for (var items of this.workGuaranteesArray){
            var guaranteeStart = null, guaranteeEnd = null;
            guaranteeStart = this.getNiceDate3(items.guarantee_start_day);
            guaranteeEnd = this.getNiceDate3(items.guarantee_end_day);

            if (items.voided_or_expired_date!=null){
              continue;
            }

            if (beginDate.getTime() == guaranteeStart.getTime()){
              return false;
            }
            if (beginDate.getTime() == guaranteeEnd.getTime()){
              return false;
            }
            if (endDate.getTime() == guaranteeStart.getTime()){
              return false;
            }
            if (endDate.getTime() == guaranteeEnd.getTime()){
              return false;
            }


             if (beginDate.getTime() > guaranteeStart.getTime() &&  beginDate.getTime() < guaranteeEnd.getTime() ){
                return false;
              }
            if (endDate.getTime() > guaranteeStart.getTime() && endDate.getTime() < guaranteeEnd.getTime() ){
              return false;
            }
          }
        return true;
      }
      return false;
  }


clearAllDates(){
  this.quickViewData.data.forEach(row => {
    this.allDatesChecked = false;
    if (row.freight_kind=="MTY" || row.charges.length==0 ||  (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER')))) {
    }else {
      this.last_begin_date = null;
      this.last_end_date = null;
      this.last_full_date = null;
      if (row.charges.length > 1) {
        for (var xxx = 0; xxx < row.charges.length; xxx++) {
          if ( (row.charges[xxx].type!=null && (row.charges[xxx].type.toUpperCase().includes('EXAM') &&  !row.charges[xxx].type.toUpperCase().includes('REDELIVER')))) {
          }else{
            row.charges[xxx].full_date = null;
            row.charges[xxx].start_date_in = null;
            row.charges[xxx].end_date_in = null;
            row.charges[xxx].nothingGood = false;
            if (row.charges[xxx].reference_number==null){
              this.selection2.deselect(row.charges[xxx]);
            }
          }
        }
      } else {
        row.full_date = null;
        row.start_date_in = null;
        row.end_date_in = null;
        row.nothingGood = false;
        if (row.reference_number==null){
          this.selection.deselect(row);
        }
      }
    }
  })
  this.turnOnButtonCheck();
}


  setAllDates() {
      this.quickViewData.data.forEach(row => {
        if (this.last_full_date==null || row.freight_kind=="MTY" || row.charges.length==0 || (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER'))) || this.last_range_mode!=row.rangeMode  ) {
        }else{
          this.allDatesChecked = true;
          if (row.charges.length>1 && row.maherError==null){
                  for (var xxx=0; xxx<row.charges.length; xxx++){
                    if ( (row.charges[xxx].type!=null && (row.charges[xxx].type.toUpperCase().includes('EXAM') &&  !row.charges[xxx].type.toUpperCase().includes('REDELIVER'))) || this.last_range_mode!=row.rangeMode || !this.checkIfDateIsGoodForDuplicate(row, row.charges[xxx].type) ) {
                    }else{
                        row.charges[xxx].full_date = this.last_full_date;
                        row.charges[xxx].start_date_in = this.last_begin_date;
                        row.charges[xxx].end_date_in = this.last_end_date;
                        this.selection2.select(row.charges[xxx]);
                      row.charges[xxx].nothingGood = false;
                    }
                  }
          }else{
            if (row.charges.length==1){
              if (row.maherError!=null || row.charges[0].flatRate=="Y" || !this.checkIfDateIsGoodForDuplicate(row, row.charges[0].type)){
              }else{
                  row.start_date_in = this.last_begin_date;
                  row.end_date_in = this.last_end_date
                  row.full_date = this.last_full_date;
                  this.selection.select(row)
                row.nothingGood = false;
              }
            }
          }
        }
      })
     this.turnOnButtonCheck();
  }

  clearAllRefernenceNumbers(){
    this.quickViewData.data.forEach(row => {
      this.allRefsChecked = false;
      this.last_reference_number = null;

      if (row.charges.length>1){
        for (var xxx=0; xxx<row.charges.length; xxx++){
          row.charges[xxx].reference_number = null;
          if (row.charges[xxx].full_date==null || row.charges[xxx].full_date==" "){
            this.selection2.deselect(row.charges[xxx]);
          }
        }
      }else{
        row.reference_number = null;
        if (row.full_date==null || row.full_date==" "){
          this.selection.deselect(row);
        }
      }
    })
   this.turnOnButtonCheck();
  }

  setAllReferenceNumbers() {
      this.quickViewData.data.forEach(row => {
        if (this.last_reference_number!=null){
          this.allRefsChecked = true;
          if (row.charges.length>1 && row.maherError==null){
               for (var xxx=0; xxx<row.charges.length; xxx++){
                  row.charges[xxx].reference_number = this.last_reference_number;
                  this.selection2.select(row.charges[xxx]);
               }
          }else{
            if (row.charges.length==1 && row.maherError==null){
              row.reference_number = this.last_reference_number;
              this.selection.select(row)
            }
          }
        }
      })

      this.turnOnButtonCheck();
  }


  checkAll(fromWhere: string) {
    if (!this.allChecked) {
      this.noneSelected = false;
      if (fromWhere == 'E') {
        this.quickViewData.data.forEach(row => {
          if (row.charges.length==0 || row.charges.length>1 || row.maherError!=null){
          }else{
            this.selection.select(row)
          }
        })
      } else {
        this.quickViewData4.data.forEach(row => {
          this.selection3.select(row)
        })
      }
      this.allChecked = true;
    } else {
      if (fromWhere == 'E') {
        this.quickViewData.data.forEach(row => {
          this.selection.deselect(row)
        })
      } else {
        this.quickViewData4.data.forEach(row => {
          this.selection3.deselect(row)
        })
      }
      this.allChecked = false;
    }

    if (fromWhere=="E"){
      this.turnOnButtonCheck();
    }


  }

  masterToggleVoid(rowIn: GuaranteesView, selected: boolean) {
    if (selected) {
      this.turnRed = false;
      this.selection3.deselect(rowIn);
    } else {
      this.turnRed = true;
      this.selection3.select(rowIn);
    }
  }


  checkBoxFlipLine(){
    if (this.checkCheckedLine){
      this.checkCheckedLine = false;
      this.bothChecked = false;
      this.iCheckedLine = false;
    }else{
      this.checkCheckedLine = true;
      this.iCheckedLine = true;
      if (this.checkCheckedMaher){
        this.bothChecked = true;
      }else{
        this.bothChecked = false;
      }
    }

  }

  checkBoxFlipMaher(){
    if (this.checkCheckedMaher){
      this.checkCheckedMaher = false;
      this.bothChecked = false;
      this.iCheckedMaher = false;
    }else{
      this.checkCheckedMaher = true;
      this.iCheckedMaher = true;
      if (this.checkCheckedLine){
        this.bothChecked = true;
      }else{
        this.bothChecked = false;
      }
  //    this.turnOnButton();
    }

  }


  turnOnButtonCheck(){
    if (this.myUser.role=="LINEOP" ){
      this.bothChecked = true;
    }else {
      this.needToCheckOffStorageSSL = false;
      this.needToCheckOffStorageMaher = false;
      for (var items of this.selection.selected) {
        if (items.category!="EXPRT"){
          var xx = this.service.isAStorageSSL(items.line_id);
          if (xx=="Y"){
            if (items.chargeDisplay=="Demurrage"){
              this.needToCheckOffStorageSSL = true;
              if (!this.iCheckedLine) {
                this.checkCheckedLine = false;
              }
              this.needToCheckOffStorageMaher = true;
              if (!this.iCheckedMaher){
                this.checkCheckedMaher = false;
              }
            }
          }else{
            if (items.chargeDisplay=="Demurrage"){
              this.needToCheckOffStorageMaher = true;
              if (!this.iCheckedMaher){
                this.checkCheckedMaher = false;
              }
            }
          }
        }
      }
      for (var items2 of this.selection2.selected) {
        if (items2.type=="STORAGE"){
          var xx = this.service.isAStorageSSL(items2.line_id);
          if (xx=="Y"){
            this.needToCheckOffStorageMaher = true;
            this.needToCheckOffStorageSSL = true;
            if (!this.iCheckedLine) {
              this.checkCheckedLine = false;
            }
            if (!this.iCheckedMaher){
              this.checkCheckedMaher = false;
            }
          }else{
            this.needToCheckOffStorageMaher = true;
            if (!this.iCheckedMaher){
              this.checkCheckedMaher = false;
            }
        }
        }
      }


      if (!this.needToCheckOffStorageSSL) {
        this.checkCheckedLine = true;
        this.iCheckedLine = false;
      }

      if (!this.needToCheckOffStorageMaher){
        this.checkCheckedMaher= true;
        this.iCheckedMaher = false;
      }

      this.turnOnButton();
    }
  }


  turnOnButton(){
    if ((this.checkCheckedMaher) && (this.selection.selected.length>0 || this.selection2.selected.length>0) && (this.checkCheckedLine)){
      this.bothChecked = true;
    }else{
      this.bothChecked = false;
    }
  }


  masterToggle(rowIn: ContainerView, selected: boolean) {
    if (selected) {
      rowIn.start_date_in = null;
      rowIn.end_date_in = null;
      rowIn.full_date = null;
      rowIn.reference_number = null;
      rowIn.nothingGood = false;
      this.selection.deselect(rowIn);
    } else {
      this.selection.select(rowIn);
    }
    this.turnOnButtonCheck();
  }

  masterToggle2(rowIn: Charge, selected: boolean) {
    if (selected) {
      rowIn.start_date_in = null;
      rowIn.end_date_in = null;
      rowIn.full_date = null;
      rowIn.reference_number = null;
      this.selection2.deselect(rowIn);
      rowIn.nothingGood = false;
    } else {
      this.selection2.select(rowIn);
    }
    this.turnOnButtonCheck();

  }

  formatDetailScreen() {
    if (this.myUser.address_2 == null) {
      this.myUser.address_2 = " ";
    }
    if (this.contView.ssl_owner_description == null) {
      this.contView.ssl_owner_description = " ";
    }
    if (this.contView.line_description == null) {
      this.contView.line_description = " ";
    }
    if (this.contView.iso_description == null) {
      this.contView.iso_description = " ";
    }
    if (this.contView.iso_description == null) {
      this.contView.iso_description = " ";
    }
    if (this.contView.category.toUpperCase() == "IMPRT") {
      if (this.contView.in_vessel_description == null) {
        this.contView.vesselDisplay = " ";
        this.contView.voyageDisplay = " ";
      } else {
        this.contView.vesselDisplay = this.contView.in_vessel_description;
        this.contView.voyageDisplay = this.contView.in_voyage;
      }
    } else {
      if (this.contView.out_vessel_description == null) {
        this.contView.vesselDisplay = " ";
        this.contView.voyageDisplay = " ";
      } else {
        this.contView.vesselDisplay = this.contView.out_vessel_description;
        this.contView.voyageDisplay = this.contView.out_voyage;
      }
    }
    if (this.contView.port_of_loading_description == null) {
      this.contView.port_of_loading_description = " ";
    }
    if (this.contView.demurrageBalanceDue == null) {
      this.contView.demurrageBalanceDue = " ";
    }
    if (this.contView.powerBalanceDue == null) {
      this.contView.powerBalanceDue = " ";
    }
    if (this.contView.examTotal == null) {
      this.contView.examTotal = " ";
    }
    if (this.contView.delivered_date_fmt == null) {
      this.contView.delivered_date_fmt = " ";
    }
    if (this.contView.fte_date_fmt == null) {
      this.contView.fte_date_fmt4 = " ";
    }else{
      this.contView.fte_date_fmt4 = this.contView.fte_date_fmt.substring(0,this.contView.fte_date_fmt.indexOf(" "));
    }
    if (this.contView.received_date_fmt == null) {
      this.contView.fte_date_fmt = " ";
    }else{
      if (this.contView.received_date_fmt.indexOf(" ")>0){
        this.contView.fte_start_date = this.contView.received_date_fmt.substring(0,this.contView.received_date_fmt.indexOf(" "));
      }
    }


    if (this.contView.guaranteesArray != null) {
      for (var yy of this.contView.guaranteesArray) {
        /*
        if (yy.event_type.toUpperCase()=='STORAGE'){
          yy.event_type = "Demurrage";
        }else if (yy.event_type.toUpperCase()=='REEFER'){
          yy.event_type = 'Power';
        }else if (yy.event_type.toUpperCase()=='SHIPSIDE EXAM'){
          yy.event_type = 'Shipside Exam';
        }else if (yy.event_type.toUpperCase()=='COAST GUARD EXAM') {
          yy.event_type = 'Coast Guard Exam';
        } else if (yy.event_type.toUpperCase() == 'GATE-EXAM') {
          yy.event_type = 'Offsite Exam';
        }else if (yy.event_type.toUpperCase()=='GATE-REDELIVERY') {
          yy.event_type = 'Export Redelivery Exam';
        }else if (yy.event_type.toUpperCase()=='GATE') {
          yy.event_type = 'Export Redelivery Exam';
        }

         */


        yy.paymentTypeDisp = yy.payment_type_description;

        yy.eventTypeDisp = yy.event_type_description + " / " + yy.paymentTypeDisp;

        yy.guarantee_amount_disp = this.getNiceCurrency(yy.guarantee_amount);

        if (yy.event_type.includes("Redelivery")) {
          yy.guarantee_amount_disp = this.getNiceCurrency(yy.totalAmount);

        }
        if (yy.guarantee_start_day != null) {
          //   yy.guarantee_start_day = this.getNiceDate(yy.guarantee_start_day);
        }
        if (yy.guarantee_end_day != null) {
          //   yy.guarantee_end_day = this.getNiceDate(yy.guarantee_end_day);
        }
        if (this.screenMode == "I") {
          if (yy.guarantee_type == "CREDIT_PREAUTHORIZE" && yy.payment_type == "CREDIT") {
            if (yy.card_type=="VISA"){
              if (yy.totalVisaFees != null) {
                yy.totalFeesVisaDisp = this.getNiceCurrency(yy.totalVisaFees.replace(/,/g, ''));
              }
            }else{
              if (yy.totalFees != null) {
                yy.totalFeesDisp = this.getNiceCurrency(yy.totalFees.replace(/,/g, ''));
              }
            }
          }
        } else {
          yy.totalFeesDisp = this.getNiceCurrency(yy.totalFees.replace(/,/g, ''));
        }

        if (this.screenMode == "I") {
          if (yy.guarantee_type != "CREDIT_PREAUTHORIZE" && yy.payment_type != "CREDIT") {
            if (yy.totalAmount != null) {
              yy.totalAmountDisp = this.getNiceCurrency(yy.totalAmount.replace(/,/g, ''));
            } else {
              yy.totalAmountDisp = yy.totalAmount;
            }
          } else {
            if (yy.card_type=="VISA"){
              if (yy.totalAmountWithVisaFee.indexOf("$") == -1) {
                yy.totalAmountVisaDisp = this.getNiceCurrency(yy.totalAmountWithVisaFee.replace(/,/g, ''));
              } else {
                yy.totalAmountVisaDisp = yy.totalAmountWithVisaFee;
              }
            }else{
              if (yy.totalAmountWithFee.indexOf("$") == -1) {
                yy.totalAmountDisp = this.getNiceCurrency(yy.totalAmountWithFee.replace(/,/g, ''));
              } else {
                yy.totalAmountDisp = yy.totalAmountWithFee;
              }
            }

          }
        } else {
          if (yy.guarantee_type != "CREDIT_PREAUTHORIZE" && yy.payment_type != "CREDIT") {
            yy.totalFeesDisp = null;
            yy.totalAmountDisp = this.getNiceCurrency(yy.totalAmount.replace(/,/g, ''));
          } else {
            yy.totalAmountDisp = this.getNiceCurrency(yy.totalAmountWithFee.replace(/,/g, ''));
          }
        }


        if (yy.voided_or_expired_date != null) {
          yy.voided_or_expired_date_disp = "Yes";
        } else {
          yy.voided_or_expired_date_disp = "No";
        }
        if (yy.created != null) {
          yy.created = this.getNiceDate(yy.created);
        }

      }

    }
  }

  nextTransaction() {


    var foundOne = false;
    var currentIdx = this.currentIndx;
    this.currentIndx++;
    if (this.currentIndx < this.contViewArray.length) {
      for (var dd = this.currentIndx; dd < this.contViewArray.length; dd++) {
        if (this.contViewArray[dd].maherError != null || this.contViewArray[dd].navisErrors != null) {
          this.currentIndx++;
          foundOne = false;
        } else {
          foundOne = true;
          break;
        }
      }
      if (!foundOne) {
        this.currentIndx = currentIdx;
      }

      this.contView = null;
      this.contView = {} as ContainerView;
      this.contView = this.contViewArray[this.currentIndx];
      if (this.contView.demurrageBalanceDueLine==null || this.contView.demurrageBalanceDueLine.includes("Contact Line")){
        this.foundStorageSSL = false;
      }else{
        this.foundStorageSSL = true;
      }
      this.guarGuarArrayHist = [];
      this.guarGuarArrayOtherHist = [];
      if (this.myUser.role == "SHIPPER") {
        this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code && xx.n4_user_id == this.myUser.username);
        this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code || (xx.guarantor == this.myUser.company_code && xx.n4_user_id != this.myUser.username));
      } else {
        this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code);
        this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code);
      }


      this.formatDetailScreen();
      this.quickViewData3 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayHist);
      this.quickViewData4 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayOtherHist);
    } else {
      this.currentIndx = this.contViewArray.length - 1;
      var _i = this.contViewArray.length;
      while (_i--) {
        if (this.contViewArray[_i].maherError != null) {
        } else {
          this.currentIndx = _i;
          break;
        }
      }
    }
  }

  previousTransaction() {
    this.currentIndx--;
    if (this.currentIndx >= 0) {
      for (var dd = this.currentIndx; dd < this.contViewArray.length; dd--) {
        if (this.contViewArray[dd].maherError != null || this.contViewArray[dd].navisErrors != null) {
          this.currentIndx--;
        } else {
          break;
        }
      }
      this.contView = null;
      this.guarGuarArrayHist = [];
      this.contView = {} as ContainerView;
      this.contView = this.contViewArray[this.currentIndx];
      if (this.contView.demurrageBalanceDueLine==null || this.contView.demurrageBalanceDueLine.includes("Contact Line")){
        this.foundStorageSSL = false;
      }else{
        this.foundStorageSSL = true;
      }

      this.guarGuarArrayHist = [];
      this.guarGuarArrayOtherHist = [];
      if (this.myUser.role == "SHIPPER") {
        this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code && xx.n4_user_id == this.myUser.username);
        this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code || (xx.guarantor == this.myUser.company_code && xx.n4_user_id != this.myUser.username));
      } else {
        this.guarGuarArrayHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor == this.myUser.company_code);
        this.guarGuarArrayOtherHist = this.contViewArray[this.currentIndx].guaranteesArray.filter(xx => xx.guarantor != this.myUser.company_code);
      }

      this.formatDetailScreen();
      this.quickViewData3 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayHist);
      this.quickViewData4 = new MatTableDataSource<GuaranteesView>(this.guarGuarArrayOtherHist);
    } else {
      this.currentIndx = 0;
    }


  }


}
